(function() {
    'use strict';
    
    // 1. Interceptar fetch para validar destinos (versión compatible)
    var originalFetch = window.fetch;
    var ALLOWED_DOMAINS = [
        'cdn.shopify.com',
        'n8n-shopify-proxy.eduardo-ba5.workers.dev',
        'levershealth.app.n8n.cloud',
        window.location.hostname
    ];
    
    window.fetch = function(url, options) {
        try {
            var urlObj = new URL(url.toString(), window.location.href);
            var isAllowed = false;
            
            for (var i = 0; i < ALLOWED_DOMAINS.length; i++) {
                if (urlObj.hostname === ALLOWED_DOMAINS[i] || 
                    urlObj.hostname.indexOf('.' + ALLOWED_DOMAINS[i]) > -1) {
                    isAllowed = true;
                    break;
                }
            }
            
            if (!isAllowed) {
                // HIPAA: Bloqueado envío a dominio no autorizado
                return Promise.reject(new Error('Dominio no autorizado'));
            }
            
            return originalFetch.apply(this, arguments);
        } catch(e) {
            return originalFetch.apply(this, arguments);
        }
    };
    
    // 2. Prevenir clickjacking básico
    if (window.top !== window.self) {
        // No forzar redirect en Shopify (puede romper embeds)
        document.body.innerHTML = '<div style="padding:20px;text-align:center;">' +
            '<h2>Security Error</h2><p>This form cannot be embedded.</p></div>';
    }
    
    // 3. Limpiar datos al salir
    window.addEventListener('beforeunload', function() {
        if (window.QZ && window.QZ.userData) {
            window.QZ.userData.answers = {};
        }
    });
})();

(function(){
    // ==========================================
    // HELPERS DE COMPARACIÓN DECLARATIVA
    // ==========================================
    var ConditionHelpers = {
        // Checks pre-loaded data (e.g., QZ.userData.Diabetes_Insulin_Resistance_History)
        equals: function(fieldName, expectedValue) {
            return function(userData) {
                var rawValue = userData[fieldName] || '';
                var normalized = userData._normalized[fieldName] || '';
                var normalizedExpected = String(expectedValue).toLowerCase().replace(/[\*\.\,\!\?\-\_\s]/g, '');
                
                // 1. Comparación exacta
                if (normalized === normalizedExpected) {
                    return true;
                }
                
                // 2. Búsqueda en valores separados por comas
                // Ej: "IBS, Persistent Acid Reflux" debe coincidir con "IBS"
                if (rawValue && typeof rawValue === 'string' && rawValue.includes(',')) {
                    var parts = rawValue.split(',').map(function(part) {
                        return part.trim().toLowerCase().replace(/[\*\.\!\?\-\_\s]/g, '');
                    });
                    return parts.indexOf(normalizedExpected) !== -1;
                }
                
                return false;
            };
        },
        exists: function(fieldName) {
            return function(userData) {
                var val = userData[fieldName];
                if (!val) return false;
                var normalized = String(val).toLowerCase().trim();
                return normalized !== '' && normalized !== 'none' && normalized !== 'null';
            };
        },
        oneOf: function(fieldName, valuesArray) {
            return function(userData) {
                var rawValue = userData[fieldName] || '';
                var normalized = userData._normalized[fieldName] || '';
                
                return valuesArray.some(function(expected) {
                    var normExpected = String(expected).toLowerCase().replace(/[\*\.\,\!\?\-\_\s]/g, '');
                    
                    // 1. Comparación exacta (modo actual)
                    if (normalized === normExpected) {
                        return true;
                    }
                    
                    // 2. Búsqueda en valores separados por comas (nuevo)
                    // Ej: "IBS, Persistent Acid Reflux" debe coincidir con "IBS"
                    if (rawValue && typeof rawValue === 'string') {
                        var parts = rawValue.split(',').map(function(part) {
                            return part.trim().toLowerCase().replace(/[\*\.\!\?\-\_]/g, '');
                        });
                        var normExpectedWithSpaces = String(expected).toLowerCase().replace(/[\*\.\!\?\-\_]/g, '');
                        return parts.some(function(part) {
                            return part === normExpectedWithSpaces || part === normExpected;
                        });
                    }
                    
                    return false;
                });
            };
        },
        // Checks answers selected inside the form (QZ.userData.answers)
        formContainsAny: function(fieldName, valuesArray) {
            return function(userData) {
                var answers = userData.answers[fieldName] || [];
                if (!Array.isArray(answers)) answers = [answers];
                return valuesArray.some(function(valueToCheck) {
                    var normalizedCheck = String(valueToCheck).toLowerCase().replace(/[\*\.\,\!\?\-\_\s]/g, '');
                    return answers.some(function(ans) {
                        var normalizedAns = String(ans).toLowerCase().replace(/[\*\.\,\!\?\-\_\s]/g, '');
                        return normalizedAns === normalizedCheck;
                    });
                });
            };
        }
    };

    // ==========================================
    // VALIDACIÓN HIPAA DE INPUTS MÉDICOS
    // ==========================================
    var SecurityUtils = {
        validateMedicalInput: function(field, value) {
            if (typeof value !== 'string') return value;
            
            var maxLengths = {
                'benefits': 500,
                'red-flags': 500,
                'healthy': 500,
                'glp-before': 500,
                'medication-tried': 500,
                'current-medication': 500,
                'recent-dose': 1000,
                'body-composition': 500,
                'goal': 500,
                'lifestyle': 100,
                'willing': 100,
                'gallbladder': 100,
                'eating-disorder': 200,
                'consent': 100,
                'default': 200
            };
            
            var max = maxLengths[field] || maxLengths.default;
            if (value.length > max) {
                throw new Error('Input exceeds maximum length for ' + field);
            }
            
            // Rechazar patrones de SQL injection
            var sqlPattern = /(\b(SELECT|INSERT|UPDATE|DELETE|DROP|UNION|EXEC|SCRIPT)\b)|(--|\/\*|\*\/|';|")/i;
            if (sqlPattern.test(value)) {
                throw new Error('Invalid characters detected in input');
            }
            
            // Rechazar HTML/JS peligroso
            var xssPattern = /<script|javascript:|on\w+\s*=|data:text\/html/i;
            if (xssPattern.test(value)) {
                throw new Error('Potentially dangerous content detected');
            }
            
            return value;
        },
        
        hashIdentifier: function(str) {
            // Hash simple para logging sin exponer PII
            var hash = 0;
            var s = String(str);
            for (var i = 0; i < s.length; i++) {
                var char = s.charCodeAt(i);
                hash = ((hash << 5) - hash) + char;
                hash = hash & hash;
            }
            return Math.abs(hash).toString(16).substring(0, 8);
        }
    };

    var CONFIG = {
        WEBHOOK_GET_DATA: "https://n8n-shopify-proxy.eduardo-ba5.workers.dev/form-intake",
        WEBHOOK_GET_DATA_FALLBACK: "https://levershealth.app.n8n.cloud/webhook/form-intake",
        WEBHOOK_SUBMIT: "https://n8n-shopify-proxy.eduardo-ba5.workers.dev/product-submission",
        WEBHOOK_SUBMIT_FALLBACK: "https://levershealth.app.n8n.cloud/webhook/product-submission",
        WEBHOOK_REFUND: "https://n8n-shopify-proxy.eduardo-ba5.workers.dev/refund",
        PRODUCT_ID: "8528639394097",
        SPECIAL_VARIANT_ID: "53010537742641", // Variant ID con flujo condicional especial

        CSRF_TOKEN: (function() {
            var arr = new Uint8Array(16);
            if (window.crypto && window.crypto.getRandomValues) {
                window.crypto.getRandomValues(arr);
            } else {
                // Fallback para navegadores antiguos
                for (var i = 0; i < 16; i++) {
                    arr[i] = Math.floor(Math.random() * 256);
                }
            }
            var hex = '';
            for (var j = 0; j < arr.length; j++) {
                hex += arr[j].toString(16).padStart(2, '0');
            }
            return hex;
        })(),
    

        FETCH_OPTIONS: {
            mode: 'cors',
            credentials: 'omit',
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json'
            }
        },
    
        // Timeout de seguridad
        SESSION_TIMEOUT: 1800000,
        MAX_RETRIES: 2,

        // ==========================================
        // MAPEO DE VARIANT IDs A NOMBRES DE PRODUCTO
        // ==========================================
        VARIANT_NAMES: {
            "51933009576241": "Semaglutide",
            "51933009609009": "Semaglutide",
            "51957331722545": "Tirzepatide", 
            "51957333197105": "Tirzepatide",
            "50271199658289": "Semaglutide", 
            "50266749632817": "Semaglutide",
            "48584862335281": "Semaglutide", 
            "47467943100721": "Tirzepatide",
            "47960550572337": "Tirzepatide", 
            "49513532588337": "Tirzepatide",
            "45775809085745": "Semaglutide", 
            "45775809151281": "Semaglutide",
            "53010537742641": "Tirzepatide",
            "53010537775409": "Tirzepatide",
        },

        VARIANT_IMG: {
            "51933009576241": "https://cdn.shopify.com/s/files/1/0779/0929/5409/files/LD_tirz_MD_sema_vials-Form.png?v=1771780242",
            "51933009609009": "https://cdn.shopify.com/s/files/1/0779/0929/5409/files/LD_tirz_MD_sema_vials-Form.png?v=1771780242",
            "51957331722545": "https://cdn.shopify.com/s/files/1/0779/0929/5409/files/LD_tirz_MD_sema_vials-Form.png?v=1771780242", 
            "51957333197105": "https://cdn.shopify.com/s/files/1/0779/0929/5409/files/LD_tirz_MD_sema_vials-Form.png?v=1771780242",
            "50271199658289": "https://cdn.shopify.com/s/files/1/0779/0929/5409/files/Semaglutide_Form.png?v=1771782203", 
            "50266749632817": "https://cdn.shopify.com/s/files/1/0779/0929/5409/files/Semaglutide_Form.png?v=1771782203",
            "48584862335281": "https://cdn.shopify.com/s/files/1/0779/0929/5409/files/Semaglutide_Form.png?v=1771782203", 
            "47467943100721": "https://cdn.shopify.com/s/files/1/0779/0929/5409/files/Tirzepatide_Form.png?v=1771802452",
            "47960550572337": "https://cdn.shopify.com/s/files/1/0779/0929/5409/files/Tirzepatide_Form.png?v=1771802452", 
            "49513532588337": "https://cdn.shopify.com/s/files/1/0779/0929/5409/files/Tirzepatide_Form.png?v=1771802452",
            "45775809085745": "https://cdn.shopify.com/s/files/1/0779/0929/5409/files/Semaglutide_Form.png?v=1771782203", 
            "45775809151281": "https://cdn.shopify.com/s/files/1/0779/0929/5409/files/Semaglutide_Form.png?v=1771782203",
            "53010537742641": "https://cdn.shopify.com/s/files/1/0779/0929/5409/files/Tirzepatide_Form.png?v=1771802452",
            "53010537775409": "https://cdn.shopify.com/s/files/1/0779/0929/5409/files/Tirzepatide_Form.png?v=1771802452"
        },

        // ==========================================
        // REGLAS DE PRECARGA (SOBRE DATOS DEL JSON)
        // ==========================================
        PRELOAD_RULES: {
            knockout: {
                'history_of_cancer': {
                    category: 'History_of_Cancer',
                    conditionValue: 'Active cancer',
                    condition: ConditionHelpers.equals('History_of_Cancer', 'Active cancer'),
                    title: 'Medical Safety Warning',
                    sub: "<strong>We're sorry, you're not eligible for GLP-1 therapy injections based upon your answers.</strong> You may be eligible for another program instead<br><br>If you believe you chose an incorrect answer by accident, you can go back and correct your answer. Otherwise, you may submit your form below to decline treatment and receive a refund",
                    msg: '<strong>We take your health very seriously.</strong> There are some conditions that we are unable to provide GLP-1 therapy for:<br>• BMI too low<br>• Active/unresolved eating disorder<br>•Pregnant or breastfeeding<br>• Type 1/2 diabetics<br>• Active cancer<br>• Serious GI issues or contraindication<br>• Not willing to consent to program terms<br>• Not willing to experience potential side effects',
                    allowBack: false,
                    redirect: 'REFUND_REQUEST'
                },
                'Pregnant': {
                    category: 'Pregnancy_And_Hormonal_Status',
                    conditionValue: 'Pregnant',
                    condition: ConditionHelpers.equals('Pregnancy_And_Hormonal_Status', 'Pregnant'),
                    title: 'Medical Safety Warning',
                    sub: "<strong>We're sorry, you're not eligible for GLP-1 therapy injections based upon your answers.</strong> You may be eligible for another program instead<br><br>If you believe you chose an incorrect answer by accident, you can go back and correct your answer. Otherwise, you may submit your form below to decline treatment and receive a refund",
                    msg: '<strong>We take your health very seriously.</strong> There are some conditions that we are unable to provide GLP-1 therapy for:<br>• BMI too low<br>• Active/unresolved eating disorder<br>•Pregnant or breastfeeding<br>• Type 1/2 diabetics<br>• Active cancer<br>• Serious GI issues or contraindication<br>• Not willing to consent to program terms<br>• Not willing to experience potential side effects',
                    allowBack: false,
                    redirect: 'REFUND_REQUEST'
                },
                'Diabetes': {
                    category: 'Diabetes_Insulin_Resistance_History',
                    conditionValue: ['Type 1', 'Type 2'],
                    condition: ConditionHelpers.oneOf('Diabetes_Insulin_Resistance_History', ['Type 1', 'Type 2']),
                    title: 'Medical Safety Warning',
                    sub: "<strong>We're sorry, you're not eligible for GLP-1 therapy injections based upon your answers.</strong> You may be eligible for another program instead<br><br>If you believe you chose an incorrect answer by accident, you can go back and correct your answer. Otherwise, you may submit your form below to decline treatment and receive a refund",
                    msg: '<strong>We take your health very seriously.</strong> There are some conditions that we are unable to provide GLP-1 therapy for:<br>• BMI too low<br>• Active/unresolved eating disorder<br>•Pregnant or breastfeeding<br>• Type 1/2 diabetics<br>• Active cancer<br>• Serious GI issues or contraindication<br>• Not willing to consent to program terms<br>• Not willing to experience potential side effects',
                    allowBack: false,
                    redirect: 'REFUND_REQUEST'
                },
                'Mental': {
                    category: 'Mental_Health_History',
                    conditionValue: 'Suicidal Attempt',
                    condition: ConditionHelpers.equals('Mental_Health_History', 'Suicidal Attempt'),
                    title: 'Medical Safety Warning',
                    sub: "<strong>We're sorry, you're not eligible for GLP-1 therapy injections based upon your answers.</strong> You may be eligible for another program instead<br><br>If you believe you chose an incorrect answer by accident, you can go back and correct your answer. Otherwise, you may submit your form below to decline treatment and receive a refund",
                    msg: '<strong>We take your health very seriously.</strong> There are some conditions that we are unable to provide GLP-1 therapy for:<br>• BMI too low<br>• Active/unresolved eating disorder<br>•Pregnant or breastfeeding<br>• Type 1/2 diabetics<br>• Active cancer<br>• Serious GI issues or contraindication<br>• Not willing to consent to program terms<br>• Not willing to experience potential side effects',
                    allowBack: false,
                    redirect: 'REFUND_REQUEST'
                }
            },
            agreement: {
                'Diabetes': {
                    category: 'Diabetes_Insulin_Resistance_History',
                    conditionValue: ['Insulin Resistance', 'Pre-Diabetes'],
                    condition: ConditionHelpers.oneOf('Diabetes_Insulin_Resistance_History', ['Insulin Resistance', 'Pre-Diabetes']),
                    insertAfterStep: 'step-welcome',
                    title: '⚠️',
                    sub: 'GLP-1 programs influence glucose regulation and blood sugar levels, usually beneficially<br><br>Individuals with pre-diabetes, insulin resistance, or elevated blood sugar must continue to monitor their condition with their primary care provider while using GLP-1 therapies, as results, tolerability, and drug interactions may vary.',
                    text: '',
                    btnAgree: 'I understand and agree',
                    btnDisagree: 'I do not agree',
                    redirectUrl: 'REFUND_REQUEST'
                },
                'Digestive': {
                    category: 'Digestive_Conditions',
                    conditionValue: ['IBS', 'Persistent Acid Reflux', 'Crohns', 'Ulcerative Colitis', 'GERD', 'Chronic Constipation', 'History of Gastric Bypass or Bariatric Surgery', 'Other'],
                    condition: ConditionHelpers.oneOf('Digestive_Conditions', ['IBS', 'Persistent Acid Reflux', 'Crohns', 'Ulcerative Colitis', 'GERD', 'Chronic Constipation', 'History of Gastric Bypass or Bariatric Surgery', 'Other']),
                    insertAfterStep: 'step-welcome',
                    title: '⚠️',
                    sub: 'If you have an ongoing digestive condition, GLP-1 medications may cause extra sensitivity in the gut.<br><br>Make sure your condition is managed, increase your dose gradually, stay hydrated, and support digestion with fiber, magnesium citrate, and electrolytes as tolerated.<br><br>Let your provider know if symptoms like nausea, bloating, constipation or reflux worsen. Often, side effects will reduce with time',
                    text: '',
                    btnAgree: 'I understand and agree',
                    btnDisagree: 'I do not agree',
                    redirectUrl: 'REFUND_REQUEST'
                },
                'Thyroid': {
                    category: 'Thyroid_Conditions',
                    conditionValue: ['Hypothyroidism', 'Hyperthyroidism', 'Thyroid Removal', 'Thyroid Tumors (non-cancerous)', 'Thyroiditis (Hashimotos or Post-Partum)', 'Goiter', 'Other'],
                    condition: ConditionHelpers.oneOf('Thyroid_Conditions', ['Hypothyroidism', 'Hyperthyroidism', 'Thyroid Removal', 'Thyroid Tumors (non-cancerous)', 'Thyroiditis (Hashimotos or Post-Partum)', 'Goiter', 'Other']),
                    insertAfterStep: 'step-welcome',
                    title: '⚠️',
                    sub: "GLP-1s aren't contraindicated if your thyroid condition is managed, but some patients notice mild changes in energy or metabolism with GLP-1 therapy; these often normalize as dosing stabilizes.<br><br>Proceed if stable under your primary/endocrine provider, continue your thyroid meds without self-adjustment, and monitor labs per their guidance.<br><br>Seek care if you develop significant fatigue, palpitations, unexplained weight changes, or other thyroid-related concerns.",
                    text: '',
                    btnAgree: 'I understand and agree',
                    btnDisagree: 'I do not agree',
                    redirectUrl: 'REFUND_REQUEST'
                },
                'Immune': {
                    category: 'Auto_immune_Conditions',
                    conditionValue: ['Lupus', 'Psoriasis', 'Hashimotos', 'Sjogren', 'Rheumatoid Arthritis', 'Addison Disease', 'Graves Disease', 'Other'],
                    condition: ConditionHelpers.oneOf('Auto_immune_Conditions', ['Lupus', 'Psoriasis', 'Hashimotos', 'Sjogren', 'Rheumatoid Arthritis', 'Addison Disease', 'Graves Disease', 'Other']),
                    insertAfterStep: 'step-welcome',
                    title: '⚠️',
                    sub: "GLP-1s are generally safe with stable autoimmune conditions. Some patients may notice mild changes in energy or inflammation as dosing adjusts.<br><br>Proceed if your condition is stable and managed by your current provider. Seek care if you experience a significant flare, new severe fatigue or joint pain, persistent GI issues, fever, or unexplained weight changes.",
                    text: '',
                    btnAgree: 'I understand and agree',
                    btnDisagree: 'I do not agree',
                    redirectUrl: 'REFUND_REQUEST'
                },
                'Mental': {
                    category: 'Mental_Health_History',
                    conditionValue: ['Anxiety', 'Depression', 'Suicidal Ideation'],
                    condition: ConditionHelpers.oneOf('Auto_immune_Conditions', ['Anxiety', 'Depression', 'Suicidal Ideation']),
                    insertAfterStep: 'step-welcome',
                    title: '⚠️',
                    sub: "Mental Health Notice: *GLP-1 medications aren't contraindicated in patients with a history of depression or anxiety, and often they can indirectly help.<br><br>But if you've ever experienced suicidal thoughts or self-harm, proceed only if stable and under care from your mental health provider. Seek immediate help if negative mood changes, hopelessness, or suicidal thoughts occur.",
                    text: '',
                    btnAgree: 'I understand and agree',
                    btnDisagree: 'I do not agree',
                    redirectUrl: 'REFUND_REQUEST'
                }
            }
        },

        // ==========================================
        // REGLAS DE FORMULARIO (SOBRE RESPUESTAS DADAS EN EL FORM)
        // ==========================================
        FORM_RULES: {
            knockout: {
                'red-flags': {
                    'History of pancreatitis': { 
                        title: "Medical Safety Warning",
                        sub: "<strong>We're sorry, you're not eligible for GLP-1 therapy injections based upon your answers.</strong> You may be eligible for another program instead.<br><br>If you believe you chose an incorrect answer by accident, you can go back and correct your answer. Otherwise, you may submit your form below to decline treatment and receive a refund.",
                        msg: "<strong>We take your health very seriously</strong>. There are some conditions that we are unable to provide GLP-1 therapy for:<br>• BMI too low<br>• Active/unresolved eating disorder<br>• Pregnant or breastfeeding<br>• Type 1/2 diabetics<br>• Active cancer<br>• Serious GI issues or contraindication<br>• Not willing to consent to program terms<br>• Not willing to experience potential side effects",
                        allowBack: true,
                        redirect: 'REFUND_REQUEST'
                    },
                    'Severe kidney disease stage 3b or higher': { 
                        title: "Medical Safety Warning",
                        sub: "<strong>We're sorry, you're not eligible for GLP-1 therapy injections based upon your answers.</strong> You may be eligible for another program instead.<br><br>If you believe you chose an incorrect answer by accident, you can go back and correct your answer. Otherwise, you may submit your form below to decline treatment and receive a refund.",
                        msg: "<strong>We take your health very seriously</strong>. There are some conditions that we are unable to provide GLP-1 therapy for:<br>• BMI too low<br>• Active/unresolved eating disorder<br>• Pregnant or breastfeeding<br>• Type 1/2 diabetics<br>• Active cancer<br>• Serious GI issues or contraindication<br>• Not willing to consent to program terms<br>• Not willing to experience potential side effects",
                        allowBack: true,
                        redirect: 'REFUND_REQUEST'
                    },
                    'Severe bowel obstruction or gastroparesis': { 
                        title: "Medical Safety Warning",
                        sub: "<strong>We're sorry, you're not eligible for GLP-1 therapy injections based upon your answers.</strong> You may be eligible for another program instead.<br><br>If you believe you chose an incorrect answer by accident, you can go back and correct your answer. Otherwise, you may submit your form below to decline treatment and receive a refund.",
                        msg: "<strong>We take your health very seriously</strong>. There are some conditions that we are unable to provide GLP-1 therapy for:<br>• BMI too low<br>• Active/unresolved eating disorder<br>• Pregnant or breastfeeding<br>• Type 1/2 diabetics<br>• Active cancer<br>• Serious GI issues or contraindication<br>• Not willing to consent to program terms<br>• Not willing to experience potential side effects",
                        allowBack: true,
                        redirect: 'REFUND_REQUEST'
                    },
                    'Severe liver disease (Cirrhosis or Decompensated)': { 
                        title: "Medical Safety Warning",
                        sub: "<strong>We're sorry, you're not eligible for GLP-1 therapy injections based upon your answers.</strong> You may be eligible for another program instead.<br><br>If you believe you chose an incorrect answer by accident, you can go back and correct your answer. Otherwise, you may submit your form below to decline treatment and receive a refund.",
                        msg: "<strong>We take your health very seriously</strong>. There are some conditions that we are unable to provide GLP-1 therapy for:<br>• BMI too low<br>• Active/unresolved eating disorder<br>• Pregnant or breastfeeding<br>• Type 1/2 diabetics<br>• Active cancer<br>• Serious GI issues or contraindication<br>• Not willing to consent to program terms<br>• Not willing to experience potential side effects",
                        allowBack: true,
                        redirect: 'REFUND_REQUEST'
                    },
                    'Family or personal history of Medullary Thyroid Carcinoma (MTC)': { 
                        title: "Medical Safety Warning",
                        sub: "<strong>We're sorry, you're not eligible for GLP-1 therapy injections based upon your answers.</strong> You may be eligible for another program instead.<br><br>If you believe you chose an incorrect answer by accident, you can go back and correct your answer. Otherwise, you may submit your form below to decline treatment and receive a refund.",
                        msg: "<strong>We take your health very seriously</strong>. There are some conditions that we are unable to provide GLP-1 therapy for Cream for:<br>• BMI too low<br>• Active/unresolved eating disorder<br>• Pregnant or breastfeeding<br>• Type 1/2 diabetics<br>• Active cancer<br>• Serious GI issues or contraindication<br>• Not willing to consent to program terms<br>• Not willing to experience potential side effects",
                        allowBack: true,
                        redirect: 'REFUND_REQUEST'
                    },
                    'Family or personal history of Multiple Endocrine Neoplasia type 2 (MEN2)': { 
                        title: "Medical Safety Warning",
                        sub: "<strong>We're sorry, you're not eligible for GLP-1 therapy injections based upon your answers.</strong> You may be eligible for another program instead.<br><br>If you believe you chose an incorrect answer by accident, you can go back and correct your answer. Otherwise, you may submit your form below to decline treatment and receive a refund.",
                        msg: "<strong>We take your health very seriously</strong>. There are some conditions that we are unable to provide GLP-1 therapy for Cream for:<br>• BMI too low<br>• Active/unresolved eating disorder<br>• Pregnant or breastfeeding<br>• Type 1/2 diabetics<br>• Active cancer<br>• Serious GI issues or contraindication<br>• Not willing to consent to program terms<br>• Not willing to experience potential side effects",
                        allowBack: true,
                        redirect: 'REFUND_REQUEST'
                    }
                },
                'willing': {
                    'No': { 
                        title: "Medical Safety Warning",
                        sub: "<strong>We're sorry, you're not eligible for GLP-1 therapy injections based upon your answers.</strong> You may be eligible for another program instead.<br><br>If you believe you chose an incorrect answer by accident, you can go back and correct your answer. Otherwise, you may submit your form below to decline treatment and receive a refund.",
                        msg: "<strong>We take your health very seriously</strong>. There are some conditions that we are unable to provide GLP-1 therapy for:<br>• BMI too low<br>• Active/unresolved eating disorder<br>• Pregnant or breastfeeding<br>• Type 1/2 diabetics<br>• Active cancer<br>• Serious GI issues or contraindication<br>• Not willing to consent to program terms<br>• Not willing to experience potential side effects",
                        allowBack: true,
                        redirect: 'REFUND_REQUEST'
                    }
                },
                'eating-disorder': {
                    'Yes, I currently have an active or unresolved eating disorder': { 
                        title: "Medical Safety Warning",
                        sub: "<strong>We're sorry, you're not eligible for GLP-1 therapy injections based upon your answers.</strong> You may be eligible for another program instead.<br><br>If you believe you chose an incorrect answer by accident, you can go back and correct your answer. Otherwise, you may submit your form below to decline treatment and receive a refund.",
                        msg: "<strong>We take your health very seriously</strong>. There are some conditions that we are unable to provide GLP-1 therapy for:<br>• BMI too low<br>• Active/unresolved eating disorder<br>• Pregnant or breastfeeding<br>• Type 1/2 diabetics<br>• Active cancer<br>• Serious GI issues or contraindication<br>• Not willing to consent to program terms<br>• Not willing to experience potential side effects",
                        allowBack: true,
                        redirect: 'REFUND_REQUEST'
                    }
                },
                'consent': {
                    'No, decline treatment': { 
                        title: "Medical Safety Warning",
                        sub: "<strong>We're sorry, you're not eligible for GLP-1 therapy injections based upon your answers.</strong> You may be eligible for another program instead.<br><br>If you believe you chose an incorrect answer by accident, you can go back and correct your answer. Otherwise, you may submit your form below to decline treatment and receive a refund.",
                        msg: "<strong>We take your health very seriously</strong>. There are some conditions that we are unable to provide GLP-1 therapy for:<br>• BMI too low<br>• Active/unresolved eating disorder<br>• Pregnant or breastfeeding<br>• Type 1/2 diabetics<br>• Active cancer<br>• Serious GI issues or contraindication<br>• Not willing to consent to program terms<br>• Not willing to experience potential side effects",
                        allowBack: true,
                        redirect: 'REFUND_REQUEST'
                    }
                },
                'lifestyle': {
                    'No': { 
                        title: "Medical Safety Warning",
                        sub: "<strong>We're sorry, you're not eligible for GLP-1 therapy injections based upon your answers.</strong> You may be eligible for another program instead.<br><br>If you believe you chose an incorrect answer by accident, you can go back and correct your answer. Otherwise, you may submit your form below to decline treatment and receive a refund.",
                        msg: "<strong>We take your health very seriously</strong>. There are some conditions that we are unable to provide GLP-1 therapy for:<br>• BMI too low<br>• Active/unresolved eating disorder<br>• Pregnant or breastfeeding<br>• Type 1/2 diabetics<br>• Active cancer<br>• Serious GI issues or contraindication<br>• Not willing to consent to program terms<br>• Not willing to experience potential side effects",
                        allowBack: true,
                        redirect: 'REFUND_REQUEST'
                    }
                }
            },
            agreement: {
                'gallbladder': {
                    'Yes': {
                        title: '⚠️',
                        sub: 'If you have an ongoing digestive condition, GLP-1 medications may cause extra sensitivity in the gut.<br><br>Make sure your condition is managed, increase your dose gradually, stay hydrated, and support digestion with fiber, magnesium citrate, and electrolytes as tolerated.<br><br>Let your provider know if symptoms like nausea, bloating, constipation or reflux worsen.',
                        text: '',
                        btnAgree: 'I understand and agree',
                        btnDisagree: 'I do not agree',
                        redirectUrl: 'REFUND_REQUEST',
                        knockout: {
                            title: "Consultation Stopped",
                            sub: "<strong>We're sorry, you're not eligible for GLP-1 therapy injections based upon your answers.</strong> You may be eligible for another program instead.<br><br>If you believe you chose an incorrect answer by accident, you can go back and correct your answer. Otherwise, you may submit your form below to decline treatment and receive a refund.",
                            msg: "<strong>We take your health very seriously</strong>. There are some conditions that we are unable to provide GLP-1 therapy for:<br>• BMI too low<br>• Active/unresolved eating disorder<br>• Pregnant or breastfeeding<br>• Type 1/2 diabetics<br>• Active cancer<br>• Serious GI issues or contraindication<br>• Not willing to consent to program terms<br>• Not willing to experience potential side effects",
                        }
                    }
                },
                'semaglutide-dose': {
                    '1.75mg/week': {
                        title: 'Levers provides a personalized titration schedule for safety and effectiveness',
                        sub: "We're ready to help you start your Tirzepatide journey:<br><br>💉 Based on your last Semaglutide dose, you’ll begin with Tirzepatide at 5mg per week, which is above the starting dose.<br><br>📈 After at least 2 weeks, if you’ve been consistent and are tolerating your dose well, you can typically increase to the next step if needed. You'll be provided with enough medication for this.<br><br>⏸️ This is a monthly program. If you pause or cancel your new subscription for more than 6 weeks between shipments, you will resume at a lower dose, for safety.<br><br>📋 Each month, you will complete a brief check-in survey to confirm progress and dosing.<br><strong>Description: You'll be provided a 30mg shipment month 1</strong>",
                        text: '',
                        btnAgree: 'I understand and agree',
                        btnDisagree: 'I do not agree',
                        redirectUrl: 'REFUND_REQUEST',
                        knockout: {
                            title: "Consultation Stopped",
                            sub: "<strong>We're sorry, you're not eligible for GLP-1 therapy injections based upon your answers.</strong> You may be eligible for another program instead.<br><br>If you believe you chose an incorrect answer by accident, you can go back and correct your answer. Otherwise, you may submit your form below to decline treatment and receive a refund.",
                            msg: "<strong>We take your health very seriously</strong>. There are some conditions that we are unable to provide GLP-1 therapy for:<br>• BMI too low<br>• Active/unresolved eating disorder<br>• Pregnant or breastfeeding<br>• Type 1/2 diabetics<br>• Active cancer<br>• Serious GI issues or contraindication<br>• Not willing to consent to program terms<br>• Not willing to experience potential side effects",
                        }
                    },
                    '2.5mg/week': {
                        title: 'Levers provides a personalized titration schedule for safety and effectiveness',
                        sub: "We're ready to help you start your Tirzepatide journey:<br><br>💉 Based on your last Semaglutide dose, you’ll begin with Tirzepatide at 5mg per week, which is above the starting dose.<br><br>📈 After at least 2 weeks, if you’ve been consistent and are tolerating your dose well, you can typically increase to the next step if needed. You'll be provided with enough medication for this.<br><br>⏸️ This is a monthly program. If you pause or cancel your new subscription for more than 6 weeks between shipments, you will resume at a lower dose, for safety.<br><br>📋 Each month, you will complete a brief check-in survey to confirm progress and dosing.<br><strong>Description: You'll be provided a 30mg shipment month 1</strong>",
                        text: '',
                        btnAgree: 'I understand and agree',
                        btnDisagree: 'I do not agree',
                        redirectUrl: 'REFUND_REQUEST',
                        knockout: {
                            title: "Consultation Stopped",
                            sub: "<strong>We're sorry, you're not eligible for GLP-1 therapy injections based upon your answers.</strong> You may be eligible for another program instead.<br><br>If you believe you chose an incorrect answer by accident, you can go back and correct your answer. Otherwise, you may submit your form below to decline treatment and receive a refund.",
                            msg: "<strong>We take your health very seriously</strong>. There are some conditions that we are unable to provide GLP-1 therapy for:<br>• BMI too low<br>• Active/unresolved eating disorder<br>• Pregnant or breastfeeding<br>• Type 1/2 diabetics<br>• Active cancer<br>• Serious GI issues or contraindication<br>• Not willing to consent to program terms<br>• Not willing to experience potential side effects",
                        }
                    },
                    '0.25mg/week': {
                        title: 'Levers provides a personalized titration schedule for safety and effectiveness',
                        sub: "We're ready to help you start your Tirzepatide journey:<br><br>💉 Based on your last Semaglutide dose, you'll begin Tirzepatide at 2.5mg per week.<br><br>📈 After at least 2 weeks, if you’ve been consistent and are tolerating your dose well, you can typically increase to the next step if needed. You'll be provided enough medication.<br><br>⏸️ This is a monthly program. If you pause or cancel your new subscription for more than 6 weeks between shipments, you will resume at a lower dose, for safety.<br><br>📋 Each month, you will complete a brief check-in survey to confirm progress and dosing.<br><strong>Description: You'll be provided a 20mg shipment month 1</strong>",
                        text: '',
                        btnAgree: 'I understand and agree',
                        btnDisagree: 'I do not agree',
                        redirectUrl: 'REFUND_REQUEST',
                        knockout: {
                            title: "Consultation Stopped",
                            sub: "<strong>We're sorry, you're not eligible for GLP-1 therapy injections based upon your answers.</strong> You may be eligible for another program instead.<br><br>If you believe you chose an incorrect answer by accident, you can go back and correct your answer. Otherwise, you may submit your form below to decline treatment and receive a refund.",
                            msg: "<strong>We take your health very seriously</strong>. There are some conditions that we are unable to provide GLP-1 therapy for:<br>• BMI too low<br>• Active/unresolved eating disorder<br>• Pregnant or breastfeeding<br>• Type 1/2 diabetics<br>• Active cancer<br>• Serious GI issues or contraindication<br>• Not willing to consent to program terms<br>• Not willing to experience potential side effects",
                        }
                    },
                    '0.5mg/week': {
                        title: 'Levers provides a personalized titration schedule for safety and effectiveness',
                        sub: "We're ready to help you start your Tirzepatide journey:<br><br>💉 Based on your last Semaglutide dose, you'll begin Tirzepatide at 2.5mg per week.<br><br>📈 After at least 2 weeks, if you’ve been consistent and are tolerating your dose well, you can typically increase to the next step if needed. You'll be provided enough medication.<br><br>⏸️ This is a monthly program. If you pause or cancel your new subscription for more than 6 weeks between shipments, you will resume at a lower dose, for safety.<br><br>📋 Each month, you will complete a brief check-in survey to confirm progress and dosing.<br><strong>Description: You'll be provided a 20mg shipment month 1</strong>",
                        text: '',
                        btnAgree: 'I understand and agree',
                        btnDisagree: 'I do not agree',
                        redirectUrl: 'REFUND_REQUEST',
                        knockout: {
                            title: "Consultation Stopped",
                            sub: "<strong>We're sorry, you're not eligible for GLP-1 therapy injections based upon your answers.</strong> You may be eligible for another program instead.<br><br>If you believe you chose an incorrect answer by accident, you can go back and correct your answer. Otherwise, you may submit your form below to decline treatment and receive a refund.",
                            msg: "<strong>We take your health very seriously</strong>. There are some conditions that we are unable to provide GLP-1 therapy for:<br>• BMI too low<br>• Active/unresolved eating disorder<br>• Pregnant or breastfeeding<br>• Type 1/2 diabetics<br>• Active cancer<br>• Serious GI issues or contraindication<br>• Not willing to consent to program terms<br>• Not willing to experience potential side effects",
                        }
                    },
                    '1mg/week': {
                        title: 'Levers provides a personalized titration schedule for safety and effectiveness',
                        sub: "We're ready to help you start your Tirzepatide journey:<br><br>💉 Based on your last Semaglutide dose, you'll begin Tirzepatide at 2.5mg per week.<br><br>📈 After at least 2 weeks, if you’ve been consistent and are tolerating your dose well, you can typically increase to the next step if needed. You'll be provided enough medication.<br><br>⏸️ This is a monthly program. If you pause or cancel your new subscription for more than 6 weeks between shipments, you will resume at a lower dose, for safety.<br><br>📋 Each month, you will complete a brief check-in survey to confirm progress and dosing.<br><strong>Description: You'll be provided a 20mg shipment month 1</strong>",
                        text: '',
                        btnAgree: 'I understand and agree',
                        btnDisagree: 'I do not agree',
                        redirectUrl: 'REFUND_REQUEST',
                        knockout: {
                            title: "Consultation Stopped",
                            sub: "<strong>We're sorry, you're not eligible for GLP-1 therapy injections based upon your answers.</strong> You may be eligible for another program instead.<br><br>If you believe you chose an incorrect answer by accident, you can go back and correct your answer. Otherwise, you may submit your form below to decline treatment and receive a refund.",
                            msg: "<strong>We take your health very seriously</strong>. There are some conditions that we are unable to provide GLP-1 therapy for:<br>• BMI too low<br>• Active/unresolved eating disorder<br>• Pregnant or breastfeeding<br>• Type 1/2 diabetics<br>• Active cancer<br>• Serious GI issues or contraindication<br>• Not willing to consent to program terms<br>• Not willing to experience potential side effects",
                        }
                    },
                    '1.25mg/week': {
                        title: 'Levers provides a personalized titration schedule for safety and effectiveness',
                        sub: "We're ready to help you start your Tirzepatide journey:<br><br>💉 Based on your last Semaglutide dose, you'll begin Tirzepatide at 2.5mg per week.<br><br>📈 After at least 2 weeks, if you’ve been consistent and are tolerating your dose well, you can typically increase to the next step if needed. You'll be provided enough medication.<br><br>⏸️ This is a monthly program. If you pause or cancel your new subscription for more than 6 weeks between shipments, you will resume at a lower dose, for safety.<br><br>📋 Each month, you will complete a brief check-in survey to confirm progress and dosing.<br><strong>Description: You'll be provided a 20mg shipment month 1</strong>",
                        text: '',
                        btnAgree: 'I understand and agree',
                        btnDisagree: 'I do not agree',
                        redirectUrl: 'REFUND_REQUEST',
                        knockout: {
                            title: "Consultation Stopped",
                            sub: "<strong>We're sorry, you're not eligible for GLP-1 therapy injections based upon your answers.</strong> You may be eligible for another program instead.<br><br>If you believe you chose an incorrect answer by accident, you can go back and correct your answer. Otherwise, you may submit your form below to decline treatment and receive a refund.",
                            msg: "<strong>We take your health very seriously</strong>. There are some conditions that we are unable to provide GLP-1 therapy for:<br>• BMI too low<br>• Active/unresolved eating disorder<br>• Pregnant or breastfeeding<br>• Type 1/2 diabetics<br>• Active cancer<br>• Serious GI issues or contraindication<br>• Not willing to consent to program terms<br>• Not willing to experience potential side effects",
                        }
                    }
                },
                'tirzepatide-dose': {
                    '15mg/week': {
                        title: 'Levers provides a personalized titration schedule for safety and effectiveness',
                        sub: "📦 Your new dosing schedule will be provided on the following screens.<br><br>⏸️ This is a monthly program. If you pause or cancel your new subscription for more than 6 weeks between shipments, you will resume at a lower dose, for safety.<br><br>📋 Each month, you will complete a brief check-in survey to confirm progress and dosing.",
                        text: '',
                        btnAgree: 'I understand and agree',
                        btnDisagree: 'I do not agree',
                        redirectUrl: 'REFUND_REQUEST',
                        knockout: {
                            title: "Consultation Stopped",
                            sub: "",
                            msg: "",
                        }
                    }
                },
                'tirzepatide-shipment': {
                    'Continue at the same/current dose': {
                        title: 'Levers provides a personalized titration schedule for safety and effectiveness',
                        sub: "📦 Your new dosing schedule will be provided on the following screens.<br><br>📈 After at least 2 weeks, if you are tolerating and have been consistent, you can typically increase the dose if needed.<br><br>⏸️ This is a monthly program. If you pause or cancel your new subscription for more than 6 weeks between shipments, you will resume at a lower dose, for safety.<br><br>📋 Each month, you will complete a brief check-in survey to confirm progress and dosing.",
                        text: '',
                        btnAgree: 'I understand and agree',
                        btnDisagree: 'I do not agree',
                        redirectUrl: 'REFUND_REQUEST',
                        knockout: {
                            title: "Consultation Stopped",
                            sub: "",
                            msg: "",
                        }
                    },
                    'Increase to the next dose level': {
                        title: 'Levers provides a personalized titration schedule for safety and effectiveness',
                        sub: "📦 Your new dosing schedule will be provided on the following screens.<br><br>📈 After at least 2 weeks, if you are tolerating and have been consistent, you can typically increase the dose if needed.<br><br>⏸️ This is a monthly program. If you pause or cancel your new subscription for more than 6 weeks between shipments, you will resume at a lower dose, for safety.<br><br>📋 Each month, you will complete a brief check-in survey to confirm progress and dosing.",
                        text: '',
                        btnAgree: 'I understand and agree',
                        btnDisagree: 'I do not agree',
                        redirectUrl: 'REFUND_REQUEST',
                        knockout: {
                            title: "Consultation Stopped",
                            sub: "",
                            msg: "",
                        }
                    }
                }
            },
            conditional_step: {
                'healthy': {
                    'Weight loss surgery': {
                        stepId: 'step-healthy',
                        title: 'Weight Loss Details',
                        question: 'Please provide details of your prior weight loss medication or surgery.',
                        fieldName: 'healthy_details',
                        required: true,
                        minLength: 2,
                        errorMsg: 'Please provide a longer answer'
                    }
                }
            }
        },

        // ==========================================
        // VARIABLES DINÁMICAS PARA SHIPMENT SUMMARY
        // Mapea la dosis actual → valores para "same" y "next"
        // ==========================================
        SHIPMENT_VARIABLES: {
            'tirzepatide-dose': {
                '2.5mg/week or less': {
                    same: { Bottle_mg: '20mg', Dosis_mg: '2.5mg/week' },
                    next: { Bottle_mg: '20mg', Dosis_mg: '5mg/week' }
                },
                '5mg/week': {
                    same: { Bottle_mg: '20mg', Dosis_mg: '5mg/week' },
                    next: { Bottle_mg: '30mg', Dosis_mg: '7.5mg/week' }
                },
                '7.5mg/week': {
                    same: { Bottle_mg: '30mg', Dosis_mg: '7.5mg/week' },
                    next: { Bottle_mg: '40mg', Dosis_mg: '10mg/week' }
                },
                '10mg/week': {
                    same: { Bottle_mg: '40mg', Dosis_mg: '10mg/week' },
                    next: { Bottle_mg: '60mg', Dosis_mg: '12.5mg/week' }
                },
                '12.5mg/week': {
                    same: { Bottle_mg: '60mg', Dosis_mg: '12.5mg/week' },
                    next: { Bottle_mg: '60mg', Dosis_mg: '15mg/week' }
                },
                '15mg/week': {
                    same: { Bottle_mg: '60mg', Dosis_mg: '15mg/week' },
                    next: { Bottle_mg: '60mg', Dosis_mg: '15mg/week' } // Max dose, no next
                }
            }
        },

        CONDITIONAL_NAVIGATION: {
            'glp-before': {
                'Yes, currently taking': {
                    insertSteps: ['step-medication-tried', 'step-current-medication', 'step-recent-dose'],
                    afterStep: 'step-glp-before',
                    variantId: '53010537742641',
                    variantSteps: ['step-recent-glp-type', 'step-last-taken-time']
                },
                'Yes, but stopped': {
                    insertSteps: ['step-medication-tried', 'step-current-medication', 'step-recent-dose'],
                    afterStep: 'step-glp-before',
                    variantId: '53010537742641',
                    variantSteps: ['step-recent-glp-type', 'step-last-taken-time']
                }
            },
            'recent-glp-type': {
                'Semaglutide (Ozempic, Wegovy)': {
                    insertSteps: ['step-semaglutide-dose'],
                    afterStep: 'step-recent-glp-type',
                    skipSteps: ['step-tirzepatide-dose']
                },
                'Tirzepatide (Mounjaro, Zepbound)': {
                    insertSteps: ['step-tirzepatide-dose'],
                    afterStep: 'step-recent-glp-type',
                    skipSteps: ['step-semaglutide-dose']
                }
            },
            'tirzepatide-dose': {
                // Configuración escalable por dosis
                // Cada dosis puede tener: insertSteps, skipSteps, requiresVerification, skipToShipment
                '2.5mg/week or less': {
                    insertSteps: ['step-tirzepatide-shipment']
                },
                '5mg/week': {
                    insertSteps: ['step-tirzepatide-shipment']
                },
                '7.5mg/week': {
                    insertSteps: ['step-tirzepatide-shipment'],
                    requiresVerification: true
                },
                '10mg/week': {
                    insertSteps: ['step-tirzepatide-shipment'],
                    requiresVerification: true
                },
                '12.5mg/week': {
                    insertSteps: ['step-tirzepatide-shipment'],
                    requiresVerification: true
                },
                '15mg/week': {
                    // Dosis máxima: NO muestra tirzepatide-shipment (no tiene sentido "increase")
                    // Pero sí requiere verificación si tiempo reciente
                    requiresVerification: true,
                    skipShipmentStep: true
                }
            },
            'tirzepatide-shipment': {
                'Continue at the same/current dose': {
                    // step-shipment-summary se inserta dinámicamente después de verificación/historial
                },
                'Increase to the next dose level': {
                    // step-shipment-summary se inserta dinámicamente después de verificación/historial
                }
            }
        }
    };

    var STEP_CONFIG = {
        'benefits': {
            min: 3,           // Mínimo requerido
            max: 3,           // Máximo permitido
            optionPrefix: null,  // Cómo se enviará en payload: "Option 1", "Option 2", etc.
            errorMsg: 'Please select at least 3 options to continue.'
        },
        'red-flags': {
            min: 1,
            max: 1,          // Ilimitado prácticamente
            optionPrefix: null,  // Se envía como array normal
            errorMsg: 'Please select at least one option.'
        },
        'healthy': {
            min: 1,
            max: 4,
            optionPrefix: null,
            errorMsg: 'Please select at least one option.'
        },
        'glp-before': {
            min: 1,
            max: 1,
            optionPrefix: null,
            errorMsg: 'Please select at least one option.'
        },
        'medication-tried': {
            min: 1,
            max: 3,
            optionPrefix: null,
            errorMsg: 'Please select at least one option.'
        },
        'current-medication': {
            min: 1,
            max: 3,
            optionPrefix: null,
            errorMsg: 'Please select at least one option'
        },
        'recent-dose': {
            minLength: 1,
            maxLength: 1000,
            required: true,
            errorMsg: 'Please provide at least 2 characters describing your current dosing.',
            isTextarea: false,           // false = input, true = textarea
            autocomplete: 'off',         // atributo HTML
            dataLpignore: 'true'         // data-lpignore="true"
        },
        'recent-glp-type': {
            min: 1,
            max: 1,
            optionPrefix: null,
            errorMsg: 'Please select one option.'
        },
        'last-taken-time': {
            min: 1,
            max: 1,
            optionPrefix: null,
            errorMsg: 'Please select one option.'
        },
        'semaglutide-dose': {
            min: 1,
            max: 1,
            optionPrefix: null,
            errorMsg: 'Please select your Semaglutide dose.'
        },
        'tirzepatide-dose': {
            min: 1,
            max: 1,
            optionPrefix: null,
            errorMsg: 'Please select your Tirzepatide dose.'
        },

        'tirzepatide-shipment': {
            min: 1,
            max: 1,
            optionPrefix: null,
            errorMsg: 'Please select an option for your shipment.'
        },
        'tirzepatide-verification': {
            min: 1,
            max: 1,
            optionPrefix: null,
            errorMsg: 'Please verify your history to continue.'
        },
        'tirzepatide-history': {
            minLength: 10,
            maxLength: 2000,
            required: true,
            errorMsg: 'Please provide at least 10 characters describing your treatment history.',
            isTextarea: true,
            autocomplete: 'off',
            dataLpignore: 'true'
        },
        'id-upload': {
            required: true,
            errorMsg: 'Please upload a valid ID photo.'
        },
        'shipment-summary': {
            min: 1,
            max: 1,
            optionPrefix: null,
            errorMsg: 'Please accept to continue.'
        },
        'body-composition': {
            min: 1,
            max: 1,
            optionPrefix: null,
            errorMsg: 'Please select at least one option'
        },
        'goal': {
            min: 1,
            max: 1,
            optionPrefix: null,
            errorMsg: 'Please select at least one option'
        }
    };

    // ==========================================
    // OPTIMIZACIÓN: Intersection Observer para carga perezosa
    // ==========================================
    var StepLazyLoader = {
        observer: null,
        
        init: function() {
            if ('IntersectionObserver' in window) {
                this.observer = new IntersectionObserver(function(entries) {
                    entries.forEach(function(entry) {
                        if (entry.isIntersecting) {
                            entry.target.dataset.visible = 'true';
                            // Precargar siguiente step si está cerca
                            var nextStep = entry.target.nextElementSibling;
                            if (nextStep && nextStep.classList.contains('qz-step')) {
                                nextStep.dataset.preload = 'true';
                            }
                        }
                    });
                }, {
                    rootMargin: '100px',
                    threshold: 0.1
                });
            }
        },
        
        observe: function(element) {
            if (this.observer) {
                this.observer.observe(element);
            }
        }
    };

    window.QZ = {
        stepIndex: 0,
        currentRoute: [],
        isSubmitting: false,
        userData: { answers: {}, orderContext: {}, existingAgreements: [] },
        domCache: {},
        formToRedirect: null,
        urlOrderId: null,

        init: function() {
            var self = this;
            var params = new URLSearchParams(window.location.search);
            var orderId = params.get('order_id');
            
            this.urlOrderId = orderId;
            
            // Asegurar que el processing overlay esté oculto al inicio
            this.hideProcessingOverlay();
            this.setupUIHelpers();
            this.applySecurityShield();

            if(!orderId) {
                this.showKnockout(
                    "Order Required",
                    "This form requires a valid purchase to access.",
                    "Please complete your purchase first to access this medical intake form.<br><br>If you believe this is an error, please contact support or click below to browse our products.",
                    false,  // allowBack: false (no puede volver atrás)
                    "https://levers.health/collections/all"  // Redirige a tienda
                );
                this.hideLoader();
                this.calculateRoute();
                this.updateUI();
                this.updateProductDisplay(); // Mostrar default
                return; // Importante: return aquí para no continuar
            }

            this.fetchData(orderId)
                .then(function(data) {
                    // ✅ NUEVO: Si el formulario ya está completado, redirigir al universal-form
                    if (data && data.completed === true) {
                        window.location.href = "https://levers.health/pages/universal-form?order_id=" + encodeURIComponent(orderId);
                        return;
                    }
                    
                    self.processOrderContext(data);
                    
                    self.updateProductDisplay();
                    var isKnockedOut = self.evaluatePreloadRules();
                    if (!isKnockedOut) {
                        self.hideLoader();
                        self.calculateRoute();
                        self.updateUI();
                    }
                })
                .catch(function(err) {
                    // Error fetching order data - continuar sin datos pre-cargados
                    // Si falla el fetch, igual permitir continuar pero sin datos pre-cargados
                    self.hideLoader();
                    self.calculateRoute();
                    self.updateUI();
                    self.updateProductDisplay();
                });
            
            this.initOptimizations();
            this.fixBackButtonMobile();
        },

        initOptimizations: function() {
            // Debounce para resize
            var resizeTimer;
            window.addEventListener('resize', function() {
                clearTimeout(resizeTimer);
                resizeTimer = setTimeout(function() {
                    // Recalcular layout si es necesario
                    if (window.QZ.updateUI) window.QZ.updateUI();
                }, 250);
            }, { passive: true });
            
            // Precargar fuentes críticas
            if ('fonts' in document) {
                document.fonts.ready.then(function() {
                    document.body.classList.add('fonts-loaded');
                });
            }
            
            // Inicializar lazy loader
            StepLazyLoader.init();
            document.querySelectorAll('.qz-step').forEach(function(step) {
                StepLazyLoader.observe(step);
            });
        },

        // Método para cachear selectores
        getCached: function(selector) {
            if (!this.domCache[selector]) {
                this.domCache[selector] = document.querySelector(selector);
            }
            return this.domCache[selector];
        },

        // Método para invalidar cache cuando cambia el DOM
        invalidateCache: function() {
            this.domCache = {};
        },

        fetchData: function(orderId, retries) {
            var self = this;
            retries = retries || CONFIG.MAX_RETRIES;
            
            return new Promise(function(resolve, reject) {
                function doFetch(url, n, onFail) {
                    var fetchOptions = {
                        method: 'POST',
                        mode: 'cors',
                        credentials: 'omit',
                        headers: {
                            'Content-Type': 'application/json',
                            'Accept': 'application/json'
                        },
                        body: JSON.stringify({ 
                            order_id: orderId, 
                            product_id: CONFIG.PRODUCT_ID,
                            ts: Date.now() 
                        })
                    };

                    fetch(url, fetchOptions)
                    .then(function(response) {
                        if (!response.ok) {
                            throw new Error("HTTP " + response.status + " - " + response.statusText);
                        }
                        return response.json();
                    })
                    .then(function(data) {
                        resolve(data);
                    })
                    .catch(function(error) {
                        if (n <= 0) {
                            onFail(error);
                        } else {
                            setTimeout(function() { doFetch(url, n-1, onFail); }, 1500);
                        }
                    });
                }
                
                doFetch(CONFIG.WEBHOOK_GET_DATA, retries, function(primaryError) {
                    if (CONFIG.WEBHOOK_GET_DATA_FALLBACK) {
                        doFetch(CONFIG.WEBHOOK_GET_DATA_FALLBACK, retries, function(fallbackError) {
                            reject(fallbackError);
                        });
                    } else {
                        reject(primaryError);
                    }
                });
            });
        },

        processOrderContext: function(data) {
            var orderData = data;
            if (!orderData || !orderData.universal_responses) { 
                return; 
            }

            if (data.form_to_redirect) {
                this.formToRedirect = data.form_to_redirect.trim();
            }

            // NUEVO: Guardar agreements existentes del JSON
            if (data.agreements && Array.isArray(data.agreements)) {
                this.userData.existingAgreements = data.agreements;
            } else {
                this.userData.existingAgreements = [];
            }

            var responses = orderData.universal_responses || {};
            var sanitizeString = function(str) {
                if (str === null || str === undefined) return '';
                return String(str).trim().replace(/[\x00-\x1F\x7F-\x9F]/g, '').replace(/\s+/g, ' ').replace(/[<>]/g, '');
            };
            var normalizeValue = function(str) {
                return sanitizeString(str).toLowerCase().replace(/[\*\.\,\!\?\-\_]/g, '').replace(/\s+/g, '');
            };

            this.userData.first_name = sanitizeString(responses.first_name);
            this.userData.last_name = sanitizeString(responses.last_name);
            this.userData.email = sanitizeString(responses.email);
            this.userData.phone = sanitizeString(responses.phone);
            this.userData.State_of_Residence = sanitizeString(responses.State_of_Residence);
            this.userData.Date_of_Birth = sanitizeString(responses.Date_of_Birth);
            this.userData.Biological_Sex = sanitizeString(responses.Biological_Sex);
            this.userData.Pregnancy_And_Hormonal_Status = sanitizeString(responses.Pregnancy_And_Hormonal_Status);
            this.userData.Diabetes_Insulin_Resistance_History = sanitizeString(responses.Diabetes_Insulin_Resistance_History);
            this.userData.Digestive_Conditions = sanitizeString(responses.Digestive_Conditions);
            this.userData.History_of_Cancer = sanitizeString(responses.History_of_Cancer);
            this.userData.Thyroid_Details = responses.Thyroid_Details ? sanitizeString(responses.Thyroid_Details) : null;
            this.userData.Mental_Health_History = sanitizeString(responses.Mental_Health_History);
            
            this.userData._normalized = {
                Diabetes_Insulin_Resistance_History: normalizeValue(this.userData.Diabetes_Insulin_Resistance_History),
                Digestive_Conditions: normalizeValue(this.userData.Digestive_Conditions),
                Pregnancy_And_Hormonal_Status: normalizeValue(this.userData.Pregnancy_And_Hormonal_Status),
                Thyroid_Details: normalizeValue(this.userData.Thyroid_Details),
                Mental_Health_History: normalizeValue(this.userData.Mental_Health_History),
                History_of_Cancer: normalizeValue(this.userData.History_of_Cancer)
            };

            // ==========================================
            // NUEVO: PROCESAMIENTO DE VARIANT_ID CON SOPORTE PARA MÚLTIPLES IDs
            // ==========================================
            var rawVariantId = orderData.variant_id || '';
            var variantIds = [];
            
            // Convertir a array (puede venir como string separado por comas, array, o string simple)
            if (typeof rawVariantId === 'string') {
                variantIds = rawVariantId.split(',').map(function(id) { 
                    return id.trim(); 
                }).filter(function(id) { 
                    return id !== ''; 
                });
            } else if (Array.isArray(rawVariantId)) {
                variantIds = rawVariantId.map(function(id) { return String(id); });
            } else {
                variantIds = [String(rawVariantId)];
            }
            
            // Encontrar el primer variantId que exista en VARIANT_NAMES
            var matchedVariantId = '';
            for (var i = 0; i < variantIds.length; i++) {
                if (CONFIG.VARIANT_NAMES[variantIds[i]]) {
                    matchedVariantId = variantIds[i];
                    break;
                }
            }
            
            // Si no hay match, usar el primero de la lista (fallback)
            if (!matchedVariantId && variantIds.length > 0) {
                matchedVariantId = variantIds[0];
            }
            
            this.userData.orderContext = {
                orderId: responses.order_id || orderData.order_id || this.urlOrderId,
                variantId: matchedVariantId,
                allVariantIds: variantIds // Guardar todos por si se necesitan después
            };
            

        },

        // ==========================================
        // ACTUALIZAR NOMBRE DE PRODUCTO DINÁMICAMENTE
        // ==========================================
        updateProductDisplay: function() {
            var variantId = this.userData.orderContext.variantId;
            var allVariantIds = this.userData.orderContext.allVariantIds || [];
            
            // Default fallback
            var productName = "Product Name";
            var imgUrl = "Null";
            
            // Si hay variant_id mapeado, usar esos valores
            // variantId ya debería ser el match correcto de processOrderContext,
            // pero como fallback extra, buscamos en todos los IDs
            if (variantId && CONFIG.VARIANT_NAMES[variantId]) {
                productName = CONFIG.VARIANT_NAMES[variantId];
                imgUrl = CONFIG.VARIANT_IMG[variantId] || "Null";
            } else if (allVariantIds.length > 0) {
                // Buscar en todos los variant IDs si el matched no está en VARIANT_NAMES
                for (var i = 0; i < allVariantIds.length; i++) {
                    var id = allVariantIds[i];
                    if (CONFIG.VARIANT_NAMES[id]) {
                        productName = CONFIG.VARIANT_NAMES[id];
                        imgUrl = CONFIG.VARIANT_IMG[id] || "Null";
                        // Actualizar el variantId matched para futuras referencias
                        this.userData.orderContext.variantId = id;
                        break;
                    }
                }
            }
            
            // Actualizar texto del título
            var titleElement = document.getElementById('qz-product-name');
            if (titleElement) {
                titleElement.textContent = productName;
            }
            
            // Actualizar imagen (tanto source como img)
            var pictureEl = document.querySelector('#step-welcome picture');
            if (pictureEl) {
                // Actualizar <source> (webp)
                var sourceEl = pictureEl.querySelector('source');
                if (sourceEl) {
                    // Mantener el format=webp pero cambiar la URL base
                    var webpUrl = imgUrl + (imgUrl.indexOf('?') > -1 ? '&' : '?') + 'format=webp';
                    sourceEl.setAttribute('srcset', webpUrl);
                }
                
                // Actualizar <img> (fallback)
                var imgEl = pictureEl.querySelector('img');
                if (imgEl) {
                    imgEl.src = imgUrl;
                    imgEl.alt = productName;
                }
            }
        },

        // NUEVO: Helper para verificar si un agreement ya existe en los datos del usuario
        hasExistingAgreement: function(category, conditionValue) {
            if (!this.userData.existingAgreements || !Array.isArray(this.userData.existingAgreements)) return false;
            
            // Si conditionValue es vacío/null/undefined, no puede haber match
            if (!conditionValue || (Array.isArray(conditionValue) && conditionValue.length === 0)) return false;
            
            var valuesToCheck = Array.isArray(conditionValue) ? conditionValue : [conditionValue];
            
            // Filtrar valores vacíos
            valuesToCheck = valuesToCheck.filter(function(v) { 
                return v && String(v).trim() !== ''; 
            });
            
            if (valuesToCheck.length === 0) return false;
            
            return this.userData.existingAgreements.some(function(existingAg) {
                if (existingAg.category !== category) return false;
                
                // Si el agreement existente tiene condition vacía, no es match válido
                if (!existingAg.condition || String(existingAg.condition).trim() === '') return false;
                
                return valuesToCheck.some(function(val) {
                    return val === existingAg.condition;
                });
            });
        },

        evaluatePreloadRules: function() {
            var userData = this.userData;
            // Check for preload knockouts first (tienen prioridad)
            for (var key in CONFIG.PRELOAD_RULES.knockout) {
                var rule = CONFIG.PRELOAD_RULES.knockout[key];
                if (rule.condition(userData)) {
                    this.showKnockout(rule.title, rule.sub, rule.msg, rule.allowBack, rule.redirect);
                    return true;
                }
            }
            return false;
        },

        calculateRoute: function() {
            var self = this;
            var route = [
                'step-welcome',
                'step-benefits',
                'step-red-flags',
                'step-healthy',
                'step-glp-before',
                'step-body-composition',
                'step-goal',
                'step-lifestyle',
                'step-willing',
                'step-gallbladder',
                'step-eating-disorder',
                'step-consent'
            ];
            
            var agreementsToAdd = [];
            
            Object.keys(CONFIG.PRELOAD_RULES.agreement).forEach(function(ruleKey) {
                var rule = CONFIG.PRELOAD_RULES.agreement[ruleKey];
                
                var hasValidCondition = rule.conditionValue && (
                    (Array.isArray(rule.conditionValue) && rule.conditionValue.length > 0) ||
                    (!Array.isArray(rule.conditionValue) && String(rule.conditionValue).trim() !== '')
                );
                
                if (rule.condition(self.userData)) {
                    agreementsToAdd.push({ ruleKey: ruleKey, rule: rule, type: 'preload' });
                }
            });

            agreementsToAdd.forEach(function(item) {
                var stepId = self.addAgreementStep(item.ruleKey, item.type);
                var insertIndex = route.indexOf(item.rule.insertAfterStep) + 1;
                if(insertIndex > 0) {
                    route.splice(insertIndex, 0, stepId);
                } else {
                    route.unshift(stepId);
                }
            });

            // Lógica correcta: sin redirect = final-submit, con redirect = confirmation
            if (this.formToRedirect && this.formToRedirect.trim() !== '') {
                route.push('step-confirmation');
            } else {
                route.push('step-final-submit');
            }

            this.baseRoute = route.slice();

            this.currentRoute = route;
        },

        next: function() {
            if (!this.currentRoute || this.currentRoute.length === 0) {
                // Route not ready yet
                return;
            }

            this.evaluateFormAgreementRules();
            
            if (this.stepIndex >= this.currentRoute.length - 1) {
                this.submitForm();
                return;
            }
            
            this.stepIndex++;
            this.updateUI();
        },

        evaluateFormAgreementRules: function() {
            var currentStepKey = this.currentRoute[this.stepIndex].replace('step-', '');
            var answers = this.userData.answers[currentStepKey] || [];
            if (!Array.isArray(answers)) answers = [answers];
            return this.evaluateFormAgreementRulesForStep(currentStepKey, answers);
        },

        evaluateFormAgreementRulesForStep: function(stepKey, answers) {
            var self = this;
            
            // LIMPIAR: Remover agreements dinámicos previos de este step
            // Esto evita que agreements de selecciones anteriores persistan
            this.currentRoute = this.currentRoute.filter(function(stepId) {
                if (!stepId.startsWith('step-agreement-')) return true;
                var stepEl = document.getElementById(stepId);
                if (!stepEl || stepEl.dataset.ruleType !== 'form') return true;
                var ruleKey = stepEl.dataset.ruleKey || '';
                // Si el agreement pertenece al step actual, lo removemos para reevaluar
                return !ruleKey.startsWith(stepKey + '_');
            });
            
            // Ahora evaluar si hay que agregar nuevos agreements según la selección actual
            if (!Array.isArray(answers)) answers = [answers];
            
            var rulesForStep = CONFIG.FORM_RULES.agreement[stepKey];
            if (!rulesForStep) return false;

            var agreementsAdded = false;
            var currentStepIndex = this.currentRoute.indexOf('step-' + stepKey);
            if (currentStepIndex === -1) currentStepIndex = this.stepIndex;

            answers.forEach(function(answer) {
                var rule = rulesForStep[answer];
                if (rule) {
                    var ruleKey = stepKey + '_' + answer.replace(/\s/g, '');
                    var stepId = self.addAgreementStep(ruleKey, 'form');
                    
                    if (self.currentRoute.indexOf(stepId) === -1) {
                        self.currentRoute.splice(currentStepIndex + 1, 0, stepId);
                        agreementsAdded = true;
                    }
                }
            });
            return agreementsAdded;
        },

        addAgreementStep: function(ruleKey, type) {
            var stepId = 'step-agreement-' + ruleKey.replace(/[^a-zA-Z0-9]/g, '_');
            if (!document.getElementById(stepId)) {
                var genericStep = document.getElementById('step-dynamic-agreement');
                if (genericStep) {
                    var clone = genericStep.cloneNode(true);
                    clone.id = stepId;
                    clone.dataset.ruleKey = ruleKey;
                    clone.dataset.ruleType = type;
                    
                    // ✅ Añadir event listeners explícitos en lugar de depender de onclick
                    var btnAgree = clone.querySelector('.qz-btn-agree-glow, .qz-btn-primary');
                    var btnDisagree = clone.querySelector('.qz-btn-secondary, .qz-btn-ghost');
                    
                    if(btnAgree) {
                        btnAgree.onclick = null; // Limpiar onclick inline
                        btnAgree.addEventListener('click', (function(self) {
                            return function() {
                                self.runWithFeedback(this, 'handleAgreement', 'agree');
                            };
                        })(this));
                    }
                    
                    if(btnDisagree) {
                        btnDisagree.onclick = null;
                        btnDisagree.addEventListener('click', (function(self) {
                            return function() {
                                self.runWithFeedback(this, 'handleAgreement', 'disagree');
                            };
                        })(this));
                    }
                    
                    genericStep.parentNode.insertBefore(clone, genericStep);
                }
            }
            return stepId;
        },

        back: function() {
            if (this.stepIndex > 0) {
                this.stepIndex--;
                this.updateUI();
            }
        },
        
        // Fix específico para botón back en dispositivos táctiles
        fixBackButtonMobile: function() {
            var backBtn = document.getElementById('qz-back-btn');
            if (!backBtn || backBtn.dataset.initialized === 'true') return;
            
            // Marcar como inicializado para no duplicar listeners
            backBtn.dataset.initialized = 'true';
            
            // Fallback para click en desktop (el touch funciona automáticamente en la mayoría de casos)
            backBtn.onclick = function(e) {
                e.preventDefault();
                e.stopPropagation();
                window.QZ.runWithFeedback(this, 'back');
            };
        },

        updateUI: function() {
            var self = this;
            document.querySelectorAll('.qz-step').forEach(function(s) { 
                s.classList.remove('active-step'); 
            });

            var currentStepId = this.currentRoute[this.stepIndex];
            var currElement = document.getElementById(currentStepId);
            
            if(currElement) currElement.classList.add('active-step');

            // Detectar si es paso de texto corto
            var stepKey = currentStepId.replace('step-', '');
            var config = STEP_CONFIG[stepKey];
            
            if (config) {
                var inputEl = this.generateShortTextField(currElement, config);
                var savedValue = this.userData.answers[stepKey];
                if (inputEl && savedValue) {
                    inputEl.value = savedValue;
                }
                var errorEl = currElement.querySelector('.qz-short-text-error');
                if (errorEl) {
                    errorEl.textContent = '';
                    errorEl.classList.remove('show-error');
                }
            }

            // === CÁLCULO AUTOMÁTICO DE BARRA DE PROGRESO ===
            // Usar currentRoute para incluir todos los pasos (base + condicionales dinámicos)
            var totalSteps = this.currentRoute.length;
            var currentPosition = this.stepIndex + 1;
            
            // Calcular progreso basado en la posición actual vs total de pasos
            var progress = (currentPosition / totalSteps) * 100;
            progress = Math.max(5, Math.min(100, progress));
            
            var bar = this.getCached('#qz-bar-fill');
            if(bar) bar.style.width = progress + '%';
            // ================================================

            if (currentStepId && currentStepId.startsWith('step-agreement-')) {
                this.renderAgreementContent(currElement);
            }

            if (currentStepId && currentStepId.startsWith('step-conditional-')) {
                this.renderConditionalContent(currElement);
            }

            if (currentStepId === 'step-shipment-summary') {
                this.renderShipmentSummary(currElement);
            }

            if (currentStepId === 'step-tirzepatide-verification') {
                this.renderTirzepatideVerification(currElement);
            }

            if (currentStepId === 'step-tirzepatide-history') {
                this.renderTirzepatideHistory(currElement);
            }

            if (currentStepId === 'step-id-upload') {
                this.renderIDUpload(currElement);
            }

            var header = this.getCached('.qz-header');
            var isWelcomeOrFirst = this.stepIndex === 0;
            if(header) header.style.setProperty('display', isWelcomeOrFirst ? 'none' : 'block', 'important');
            
            var wrapper = document.getElementById('qz-wrapper');
            wrapper.classList.add('qz-focus-mode'); 
            document.body.classList.add('qz-lock-body');
            wrapper.scrollTop = 0;
            
            // Fix para botón back en móvil - solo llamar una vez
            if (!this.backButtonFixed) {
                this.fixBackButtonMobile();
                this.backButtonFixed = true;
            } 
        },

        runWithFeedback: function(btn, fnName) {
            btn.classList.add('qz-btn-processing');
            var self = this;
            // Obtener argumentos adicionales (después de fnName)
            var args = Array.prototype.slice.call(arguments, 2);
            
            setTimeout(function(){
                btn.classList.remove('qz-btn-processing');
                if(typeof self[fnName] === 'function') {
                    // Para selectAndNext, el primer argumento es el elemento (btn)
                    if (fnName === 'selectAndNext') {
                        // args[0] = key, args[1] = val
                        self[fnName](btn, args[0], args[1]);
                    } else {
                        self[fnName].apply(self, args);
                    }
                }
            }, 500);
        },

        // Nueva función para manejar selección con límites
        toggleMultiLimited: function(el, key) {
            if(document.activeElement) document.activeElement.blur();
            
            var config = STEP_CONFIG[key];
            if (!config) {
                // Fallback a toggleMulti normal si no hay config
                return this.toggleMulti(el, key, el.dataset.value, false);
            }
            
            var min = config.min || 1;
            var max = config.max || 10;
            var listContainer = document.getElementById(key + '-list') || el.parentElement;
            
            // Inicializar array si no existe
            if (!Array.isArray(this.userData.answers[key])) { 
                this.userData.answers[key] = []; 
            }
            
            var currentArr = this.userData.answers[key];
            var val = el.dataset.value;
            var isSelected = el.classList.contains('active-opt');
            
            // Si está seleccionado, lo quitamos (siempre permitido quitar)
            if (isSelected) {
                el.classList.remove('active-opt');
                this.userData.answers[key] = currentArr.filter(function(item) { 
                    return item !== val; 
                });
                this.updateSelectionVisuals(key, max);
                this.updateCounter(key, min, max);
                this.clearError('qz-' + key);
                return;
            }
            
            // Si no está seleccionado y ya llegamos al máximo, no hacer nada
            if (currentArr.length >= max) {
                // Efecto visual de "shake" para indicar que no se puede
                el.style.animation = 'qz-shake 0.3s ease-in-out';
                setTimeout(function() { el.style.animation = ''; }, 300);
                return;
            }
            
            // Agregar a la selección
            el.classList.add('active-opt');
            this.userData.answers[key].push(val);
            
            // Actualizar visuales y contador
            this.updateSelectionVisuals(key, max);
            this.updateCounter(key, min, max);
            this.clearError('qz-' + key);
        },

        // Actualizar contador visual
        updateCounter: function(key, min, max) {
            var counterEl = document.getElementById(key + '-counter');
            if (!counterEl) return;
            
            var count = (this.userData.answers[key] || []).length;
            counterEl.textContent = 'Selected: ' + count + '/' + max;
            
            // Cambiar estilo según estado
            counterEl.classList.remove('complete', 'warning');
            if (count >= min) {
                counterEl.classList.add('complete');
            } else if (count > 0) {
                counterEl.classList.add('warning');
            }
        },

        // Actualizar visuales de opciones deshabilitadas
        updateSelectionVisuals: function(key, max) {
            var listContainer = document.getElementById(key + '-list');
            if (!listContainer) return;
            
            var count = (this.userData.answers[key] || []).length;
            var allOptions = listContainer.querySelectorAll('.qz-option');
            var isMaxReached = count >= max;
            
            allOptions.forEach(function(opt) {
                var isSelected = opt.classList.contains('active-opt');
                
                if (isMaxReached && !isSelected) {
                    opt.classList.add('disabled-option');
                } else {
                    opt.classList.remove('disabled-option');
                }
            });
        },

        // Validación mejorada
        validateMultiLimited: function(key) {
            var config = STEP_CONFIG[key];
            if (!config) {
                return this.validateMulti(key);
            }
            
            var answers = this.userData.answers[key] || [];
            var min = config.min || 1;
            
            if (answers.length < min) {
                this.showError('qz-' + key, config.errorMsg || 'Please select at least ' + min + ' option(s).');
                
                // Efecto visual en el contador
                var counterEl = document.getElementById(key + '-counter');
                if (counterEl) {
                    counterEl.style.animation = 'qz-shake 0.5s ease-in-out';
                    setTimeout(function() { counterEl.style.animation = ''; }, 500);
                }
                return false;
            }
            
            // Verificar knockouts si existen
            var knockoutRulesForStep = CONFIG.FORM_RULES.knockout[key];
            if (knockoutRulesForStep) {
                for (var i = 0; i < answers.length; i++) {
                    var answer = answers[i];
                    var rule = knockoutRulesForStep[answer];
                    if (rule) {
                        this.showKnockout(rule.title, rule.sub, rule.msg, rule.allowBack, rule.redirect);
                        return false;
                    }
                }
            }

            var conditionalRules = CONFIG.FORM_RULES.conditional_step[key];
            if (conditionalRules) {
                for (var j = 0; j < answers.length; j++) {
                    var ans = answers[j];
                    var condRule = conditionalRules[ans];
                    if (condRule) {
                        // Crear paso condicional dinámico
                        var stepId = this.addConditionalStep(key, ans, condRule);
                        if (this.currentRoute.indexOf(stepId) === -1) {
                            this.currentRoute.splice(this.stepIndex + 1, 0, stepId);
                        }
                    }
                }
            }
            
            // Evaluar navegación condicional
            if (answers.length === 1) {
                var navRules = CONFIG.CONDITIONAL_NAVIGATION[key];
                var answer = answers[0];
                
                // Siempre limpiar pasos condicionales previos de este step (para cambios de opinión)
                if (navRules) {
                    if (navRules[answer]) {
                        // Hay regla para esta respuesta - aplicar navegación condicional
                        this.evaluateConditionalNavigation(key, answer);
                    } else {
                        // No hay regla para esta respuesta - limpiar pasos condicionales previos
                        this.clearConditionalSteps(key);
                    }
                }
                
                // ✅ ESPECIAL: Manejo condicional para tirzepatide-dose basado en last-taken-time
                if (key === 'tirzepatide-dose') {
                    this.handleTirzepatideDoseNavigation(answer);
                }
            }
            
            // Evaluar agreements para este paso antes de avanzar
            this.evaluateFormAgreementRulesForStep(key, answers);
            
            // ✅ Si es tirzepatide-shipment, evaluar si se necesita verificación
            if (key === 'tirzepatide-shipment') {
                this.evaluateHighDoseVerification();
            }
            
            // ✅ Si es tirzepatide-history (nuevo paciente), insertar shipment-summary después
            if (key === 'tirzepatide-history') {
                this.insertShipmentSummaryAfterHistory();
            }
            
            this.next();
        },

        addConditionalStep: function(key, answer, rule) {
            var stepId = 'step-conditional-' + key + '-' + answer.replace(/\s/g, '_').toLowerCase();
            
            if (!document.getElementById(stepId)) {
                var template = document.getElementById('step-dynamic-conditional');
                if (template) {
                    var clone = template.cloneNode(true);
                    clone.id = stepId;
                    clone.style.display = ''; // Quitar display:none
                    clone.dataset.parentKey = key;
                    clone.dataset.triggerAnswer = answer;
                    clone.dataset.fieldName = rule.fieldName;
                    
                    // Personalizar contenido
                    var titleEl = clone.querySelector('#qz-conditional-title');
                    var questionEl = clone.querySelector('#qz-conditional-question');
                    var inputEl = clone.querySelector('#qz-conditional-input');
                    var errorEl = clone.querySelector('#qz-conditional-error');
                    
                    if(titleEl) {
                        titleEl.id = 'qz-conditional-title-' + stepId;
                        titleEl.textContent = rule.title;
                    }
                    if(questionEl) {
                        questionEl.id = 'qz-conditional-question-' + stepId;
                        questionEl.innerHTML = rule.question;
                    }
                    if(inputEl) {
                        inputEl.id = 'qz-conditional-input-' + stepId;
                        inputEl.placeholder = rule.placeholder || 'Type your answer here...';
                        if(rule.minLength) inputEl.dataset.minLength = rule.minLength;
                    }
                    if(errorEl) errorEl.id = 'qz-conditional-error-' + stepId;
                    
                    // Limpiar IDs duplicados en botones
                    var buttons = clone.querySelectorAll('button');
                    buttons.forEach(function(btn, idx) {
                        btn.removeAttribute('id');
                        btn.dataset.stepId = stepId;
                    });
                    
                    template.parentNode.insertBefore(clone, template);
                }
            }
            return stepId;
        },

        handleConditionalStep: function(action) {
            var currentStepEl = document.getElementById(this.currentRoute[this.stepIndex]);
            if (!currentStepEl) return;
            
            var stepId = currentStepEl.id;
            var fieldName = currentStepEl.dataset.fieldName;
            var inputEl = document.getElementById('qz-conditional-input-' + stepId);
            var errorEl = document.getElementById('qz-conditional-error-' + stepId);
            
            if (action === 'back') {
                // Limpiar y volver
                if(inputEl) inputEl.value = '';
                if(errorEl) {
                    errorEl.textContent = '';
                    errorEl.classList.remove('show-error');
                }
                this.back();
                return;
            }
            
            // Validar input
            if (!inputEl) return;
            
            var value = inputEl.value.trim();
            var minLength = parseInt(inputEl.dataset.minLength) || 1;
            var rule = this.getConditionalRule(currentStepEl.dataset.parentKey, currentStepEl.dataset.triggerAnswer);
            
            if (value.length < minLength) {
                if(errorEl) {
                    errorEl.textContent = rule.errorMsg || 'Please provide more details.';
                    errorEl.classList.add('show-error');
                }
                inputEl.classList.add('input-error');
                return;
            }
            
            // Guardar respuesta
            if (!this.userData.answers.conditional) this.userData.answers.conditional = {};
            this.userData.answers.conditional[fieldName] = value;
            
            // Limpiar error visual
            inputEl.classList.remove('input-error');
            if(errorEl) errorEl.classList.remove('show-error');
            
            this.next();
        },

        renderConditionalContent: function(stepEl) {
            var parentKey = stepEl.dataset.parentKey;
            var triggerAnswer = stepEl.dataset.triggerAnswer;
            
            if (!parentKey || !triggerAnswer) return;
            
            var rule = this.getConditionalRule(parentKey, triggerAnswer);
            if (!rule) return;

            var stepId = stepEl.id;
            var titleEl = document.getElementById('qz-conditional-title-' + stepId);
            var questionEl = document.getElementById('qz-conditional-question-' + stepId);
            var inputEl = document.getElementById('qz-conditional-input-' + stepId);
            
            if(titleEl) titleEl.textContent = rule.title || 'Additional Information';
            if(questionEl) questionEl.innerHTML = rule.question || 'Please provide more details.';
            if(inputEl) {
                if(rule.placeholder) inputEl.placeholder = rule.placeholder;
                if(rule.minLength) inputEl.dataset.minLength = rule.minLength;
                
                // Restaurar valor si ya existe
                if (this.userData.answers.conditional && this.userData.answers.conditional[rule.fieldName]) {
                    inputEl.value = this.userData.answers.conditional[rule.fieldName];
                }
            }
        },

        // Helper para obtener la regla
        getConditionalRule: function(key, answer) {
            var rules = CONFIG.FORM_RULES.conditional_step[key];
            return rules ? rules[answer] : null;
        },

        // Manejar selección de archivo de ID
        handleFileSelect: function(input) {
            var self = this; // ✅ FIX: Definir self para usar en callback
            var stepEl = document.getElementById('step-id-upload');
            var errorEl = document.getElementById('qz-id-file-error');
            var initUi = document.getElementById('qz-upload-init-ui');
            var successUi = document.getElementById('qz-upload-success-ui');
            var previewImg = document.getElementById('qz-id-preview');
            var dropzone = document.getElementById('qz-dropzone');
            
            // Limpiar error previo
            if (errorEl) {
                errorEl.textContent = '';
                errorEl.classList.remove('show-error');
            }
            
            // Validar que hay archivo
            if (!input.files || input.files.length === 0) return;
            
            var file = input.files[0];
            
            // Validar tipo de archivo
            if (!file.type.startsWith('image/')) {
                if (errorEl) {
                    errorEl.textContent = 'Please upload an image file (JPG, PNG, etc.)';
                    errorEl.classList.add('show-error');
                }
                input.value = '';
                return;
            }
            
            // Validar tamaño (máximo 10MB)
            if (file.size > 10 * 1024 * 1024) {
                if (errorEl) {
                    errorEl.textContent = 'File is too large. Maximum size is 10MB.';
                    errorEl.classList.add('show-error');
                }
                input.value = '';
                return;
            }
            
            // Crear preview
            var reader = new FileReader();
            reader.onload = function(e) {
                if (previewImg) previewImg.src = e.target.result;
                
                // Guardar en userData
                if (!self.userData.answers['id-upload']) self.userData.answers['id-upload'] = {};
                self.userData.answers['id-upload'].file = file;
                self.userData.answers['id-upload'].preview = e.target.result;
                
                // Mostrar UI de éxito
                if (initUi) initUi.classList.add('qz-hidden');
                if (successUi) successUi.classList.remove('qz-hidden');
                if (dropzone) dropzone.classList.add('has-file');
            };
            reader.onerror = function() {
                if (errorEl) {
                    errorEl.textContent = 'Error reading file. Please try again.';
                    errorEl.classList.add('show-error');
                }
            };
            reader.readAsDataURL(file);
        },

        // Validar subida de ID
        validateIDUpload: function() {
            var stepEl = document.getElementById('step-id-upload');
            var errorEl = document.getElementById('qz-id-file-error');
            
            // Verificar si hay archivo
            var idData = this.userData.answers['id-upload'];
            if (!idData || !idData.file) {
                if (errorEl) {
                    errorEl.textContent = 'Please upload a valid ID photo to continue.';
                    errorEl.classList.add('show-error');
                }
                return;
            }
            
            // Limpiar error
            if (errorEl) {
                errorEl.textContent = '';
                errorEl.classList.remove('show-error');
            }
            
            // Continuar al siguiente paso
            this.next();
        },

        // Renderizar paso de historial de Tirzepatide
        renderTirzepatideHistory: function(stepEl) {
            var inputEl = stepEl.querySelector('#tirzepatide-history-input');
            var errorEl = stepEl.querySelector('#qz-tirzepatide-history-error');
            
            // Limpiar errores
            if (inputEl) {
                inputEl.classList.remove('input-error');
                // Restaurar valor si existe
                if (this.userData.answers['tirzepatide-history']) {
                    inputEl.value = this.userData.answers['tirzepatide-history'];
                }
            }
            if (errorEl) {
                errorEl.textContent = '';
                errorEl.classList.remove('show-error');
            }
        },

        // Comprimir imagen antes de enviar
        compressImage: function(base64String, maxWidth, maxHeight, quality) {
            return new Promise(function(resolve, reject) {
                var img = new Image();
                img.src = base64String;
                
                img.onload = function() {
                    var canvas = document.createElement('canvas');
                    var ctx = canvas.getContext('2d');
                    
                    // Calcular nuevas dimensiones manteniendo ratio
                    var width = img.width;
                    var height = img.height;
                    
                    if (width > height) {
                        if (width > maxWidth) {
                            height *= maxWidth / width;
                            width = maxWidth;
                        }
                    } else {
                        if (height > maxHeight) {
                            width *= maxHeight / height;
                            height = maxHeight;
                        }
                    }
                    
                    canvas.width = width;
                    canvas.height = height;
                    
                    // Dibujar imagen comprimida
                    ctx.drawImage(img, 0, 0, width, height);
                    
                    // Convertir a base64 con calidad reducida
                    var compressedBase64 = canvas.toDataURL('image/jpeg', quality);
                    resolve(compressedBase64);
                };
                
                img.onerror = function() {
                    reject(new Error('Failed to load image'));
                };
            });
        },

        // Renderizar paso de subida de ID
        renderIDUpload: function(stepEl) {
            var errorEl = stepEl.querySelector('#qz-id-file-error');
            
            // Limpiar errores
            if (errorEl) {
                errorEl.textContent = '';
                errorEl.classList.remove('show-error');
            }
            
            // Si ya hay archivo subido, mostrar preview
            var idData = this.userData.answers['id-upload'];
            if (idData && idData.preview) {
                var initUi = document.getElementById('qz-upload-init-ui');
                var successUi = document.getElementById('qz-upload-success-ui');
                var previewImg = document.getElementById('qz-id-preview');
                var dropzone = document.getElementById('qz-dropzone');
                
                if (previewImg) previewImg.src = idData.preview;
                if (initUi) initUi.classList.add('qz-hidden');
                if (successUi) successUi.classList.remove('qz-hidden');
                if (dropzone) dropzone.classList.add('has-file');
            }
        },

        // Renderizar contenido dinámico del shipment summary
        renderShipmentSummary: function(stepEl) {
            // 1. Obtener la selección del usuario: "same" o "next"
            var shipmentChoice = this.userData.answers['tirzepatide-shipment'];
            var doseType = 'same';
            
            if (shipmentChoice && (!Array.isArray(shipmentChoice) || shipmentChoice.length > 0)) {
                var selectedOption = Array.isArray(shipmentChoice) ? shipmentChoice[0] : shipmentChoice;
                // Determinar si es "same" o "next"
                if (selectedOption === 'Increase to the next dose level') {
                    doseType = 'next';
                }
            } else {
                // Si no hay selección de tirzepatide-shipment (ej: vino de last-taken-time con skip)
                // usar el tipo guardado en _shipmentSummaryDoseType
                if (this.userData._shipmentSummaryDoseType) {
                    doseType = this.userData._shipmentSummaryDoseType;
                }
            }
            
            // 2. Obtener la dosis anterior seleccionada en tirzepatide-dose
            var doseAnswer = this.userData.answers['tirzepatide-dose'];
            if (!doseAnswer || (Array.isArray(doseAnswer) && doseAnswer.length === 0)) {
                return;
            }
            
            var selectedDose = Array.isArray(doseAnswer) ? doseAnswer[0] : doseAnswer;
            selectedDose = String(selectedDose).trim();
            
            // 3. Valores por defecto
            var bottleMg = '20mg';
            var dosisMg = selectedDose;
            
            // 4. Buscar valores en CONFIG según dosis y tipo (same/next)
            try {
                if (typeof CONFIG !== 'undefined' && CONFIG.SHIPMENT_VARIABLES && CONFIG.SHIPMENT_VARIABLES['tirzepatide-dose']) {
                    var doseConfig = CONFIG.SHIPMENT_VARIABLES['tirzepatide-dose'];
                    var doseData = doseConfig[selectedDose];
                    
                    // Si no hay coincidencia exacta, buscar coincidencia parcial
                    if (!doseData) {
                        for (var doseKey in doseConfig) {
                            if (doseConfig.hasOwnProperty(doseKey)) {
                                var doseKeyClean = String(doseKey).trim();
                                if (selectedDose === doseKeyClean || 
                                    selectedDose.indexOf(doseKeyClean) !== -1 || 
                                    doseKeyClean.indexOf(selectedDose) !== -1) {
                                    doseData = doseConfig[doseKey];
                                    break;
                                }
                            }
                        }
                    }
                    
                    // Usar valores según si es "same" o "next"
                    if (doseData && doseData[doseType]) {
                        bottleMg = doseData[doseType].Bottle_mg || bottleMg;
                        dosisMg = doseData[doseType].Dosis_mg || dosisMg;
                    }
                }
            } catch (e) {
                // Si hay error, usar valores por defecto
            }
            
            // 5. Renderizar contenido en los nuevos elementos
            var titleEl = stepEl.querySelector('#shipment-summary-title');
            if (titleEl) {
                titleEl.innerHTML = '<span class="qz-gradient-text">Your Treatment Plan</span>';
            }
            
            // Texto principal
            var textEl = stepEl.querySelector('#shipment-summary-text');
            if (textEl) {
                textEl.innerHTML = '<strong>' + bottleMg + '</strong> bottle of Tirzepatide<br>Starting at <strong>' + dosisMg + '</strong>';
            }
            
            // Bottle display
            var bottleEl = stepEl.querySelector('#shipment-bottle-display');
            if (bottleEl) {
                bottleEl.textContent = bottleMg;
            }
            
            // Dose display
            var doseEl = stepEl.querySelector('#shipment-dose-display');
            if (doseEl) {
                doseEl.textContent = dosisMg;
            }
        },

        // Renderizar contenido del paso de verificación de Tirzepatide
        renderTirzepatideVerification: function(stepEl) {
            // Obtener la dosis seleccionada
            var doseAnswer = this.userData.answers['tirzepatide-dose'];
            if (!doseAnswer || (Array.isArray(doseAnswer) && doseAnswer.length === 0)) return;
            
            var selectedDose = Array.isArray(doseAnswer) ? doseAnswer[0] : doseAnswer;
            
            // Actualizar el texto con la dosis
            var doseDisplayEl = stepEl.querySelector('#verification-dose-display');
            if (doseDisplayEl) {
                doseDisplayEl.textContent = selectedDose;
            }
            
            // Resetear estado del botón
            var btnCheck = stepEl.querySelector('#btn-check-history');
            var btnContinue = stepEl.querySelector('#btn-continue-verification');
            var successMsg = stepEl.querySelector('#qz-verification-success');
            
            if (btnCheck) {
                btnCheck.disabled = false;
                btnCheck.style.display = 'flex';
                btnCheck.querySelector('span').textContent = 'Check my history';
            }
            if (btnContinue) btnContinue.style.display = 'none';
            if (successMsg) successMsg.style.display = 'none';
        },

        // Verificar historial de Tirzepatide vía webhook
        checkTirzepatideHistory: function() {
            var self = this;
            var stepEl = document.getElementById('step-tirzepatide-verification');
            var successMsg = stepEl.querySelector('#qz-verification-success');
            var newPatientMsg = stepEl.querySelector('#qz-verification-new-patient');
            var btnCheck = stepEl.querySelector('#btn-check-history');
            
            // Obtener la dosis seleccionada
            var doseAnswer = this.userData.answers['tirzepatide-dose'];
            var selectedDose = Array.isArray(doseAnswer) ? doseAnswer[0] : doseAnswer;
            
            // Mostrar loader del formulario
            this.showProcessingOverlay();
            
            // Preparar payload
            var payload = {
                order_id: this.urlOrderId || this.userData.orderContext.orderId || null,
                dose_mg_per_week: selectedDose,
                ts: new Date().toISOString()
            };
            
            // Hacer fetch al webhook
            fetch('https://n8n.levers.health/webhook/check-tirz', {
                method: 'POST',
                mode: 'cors',
                headers: {
                    'Content-Type': 'application/json',
                    'Accept': 'application/json'
                },
                body: JSON.stringify(payload)
            })
            .then(function(response) {
                if (!response.ok) throw new Error('HTTP ' + response.status);
                return response.json();
            })
            .then(function(data) {
                // Ocultar loader
                self.hideProcessingOverlay();
                
                // Verificar respuesta
                if (data && data.success === true) {
                    // Paciente existente de Levers
                    if (data.levers_patient === true) {
                        if (successMsg) {
                            // Mensaje VERDE para pacientes Levers (confirmación positiva)
                            successMsg.textContent = '✓ Welcome back! Your history has been verified. You can continue.';
                            successMsg.style.background = '#DCFCE7';
                            successMsg.style.borderColor = '#22C55E';
                            successMsg.style.color = '#166534';
                            successMsg.style.display = 'block';
                        }
                        // Insertar shipment-summary después de la verificación
                        self.insertShipmentSummaryAfterVerification();
                        // Cambiar botón a "Continue" - NO saltar automáticamente
                        if (btnCheck) {
                            btnCheck.disabled = false;
                            btnCheck.querySelector('span').textContent = 'Continue';
                            // Cambiar onclick para que vaya al siguiente paso
                            btnCheck.onclick = function() {
                                self.runWithFeedback(this, 'next');
                            };
                        }
                    } else {
                        // Nuevo paciente, necesita describir historial
                        if (newPatientMsg) {
                            newPatientMsg.textContent = 'We need a bit more information about your treatment history.';
                            newPatientMsg.style.display = 'block';
                        }
                        // Insertar paso de historial (shipment-summary irá después del history)
                        self.insertTirzepatideHistoryStep();
                        // Cambiar botón a "Continue" - NO saltar automáticamente
                        if (btnCheck) {
                            btnCheck.disabled = false;
                            btnCheck.querySelector('span').textContent = 'Continue';
                            // Cambiar onclick para que vaya al siguiente paso
                            btnCheck.onclick = function() {
                                self.runWithFeedback(this, 'next');
                            };
                        }
                    }
                } else {
                    throw new Error('Invalid response');
                }
            })
            .catch(function(error) {
                // Ocultar loader
                self.hideProcessingOverlay();
                
                // Mostrar error pero permitir reintentar
                if (btnCheck) {
                    btnCheck.disabled = false;
                    btnCheck.querySelector('span').textContent = 'Try again';
                }
                if (successMsg) {
                    successMsg.textContent = 'Could not verify history. Please try again.';
                    successMsg.style.background = '#FEE2E2';
                    successMsg.style.borderColor = '#EF4444';
                    successMsg.style.color = '#991B1B';
                    successMsg.style.display = 'block';
                }
            });
        },

        // Insertar paso de historial de Tirzepatide después del verification
        insertTirzepatideHistoryStep: function() {
            var historyStepId = 'step-tirzepatide-history';
            var verificationIndex = this.currentRoute.indexOf('step-tirzepatide-verification');
            
            if (verificationIndex !== -1 && this.currentRoute.indexOf(historyStepId) === -1) {
                this.currentRoute.splice(verificationIndex + 1, 0, historyStepId);
            }
        },

        // Validar historial de Tirzepatide
        validateTirzepatideHistory: function() {
            var stepEl = document.getElementById('step-tirzepatide-history');
            var inputEl = document.getElementById('tirzepatide-history-input');
            var errorEl = document.getElementById('qz-tirzepatide-history-error');
            
            if (!inputEl) {
                this.next();
                return;
            }
            
            var value = inputEl.value.trim();
            
            // Validar que no esté vacío
            if (value.length === 0) {
                if (errorEl) {
                    errorEl.textContent = 'Please describe your treatment history.';
                    errorEl.classList.add('show-error');
                }
                inputEl.classList.add('input-error');
                return;
            }
            
            // Validar longitud mínima
            if (value.length < 10) {
                if (errorEl) {
                    errorEl.textContent = 'Please provide more details (at least 10 characters).';
                    errorEl.classList.add('show-error');
                }
                inputEl.classList.add('input-error');
                return;
            }
            
            // Validar longitud máxima (HIPAA)
            if (value.length > 2000) {
                if (errorEl) {
                    errorEl.textContent = 'Response is too long. Please be more concise.';
                    errorEl.classList.add('show-error');
                }
                inputEl.classList.add('input-error');
                return;
            }
            
            // Sanitizar input
            try {
                value = SecurityUtils.validateMedicalInput('tirzepatide-history', value);
            } catch (e) {
                if (errorEl) {
                    errorEl.textContent = 'Invalid characters detected.';
                    errorEl.classList.add('show-error');
                }
                return;
            }
            
            // Limpiar errores
            inputEl.classList.remove('input-error');
            if (errorEl) {
                errorEl.textContent = '';
                errorEl.classList.remove('show-error');
            }
            
            // Guardar respuesta
            this.userData.answers['tirzepatide-history'] = value;
            
            // Insertar ID upload y shipment-summary después del historial
            this.insertShipmentSummaryAfterHistory();
            
            this.next();
        },

        // Evaluar si se necesita paso de verificación para dosis altas
        evaluateHighDoseVerification: function() {
            // Obtener la dosis seleccionada en tirzepatide-dose
            var doseAnswer = this.userData.answers['tirzepatide-dose'];
            if (!doseAnswer || (Array.isArray(doseAnswer) && doseAnswer.length === 0)) return;
            
            var selectedDose = Array.isArray(doseAnswer) ? doseAnswer[0] : doseAnswer;
            selectedDose = String(selectedDose).trim();
            
            // Dosis que requieren verificación
            var highDoses = ['7.5mg/week', '10mg/week', '12.5mg/week', '15mg/week'];
            var requiresVerification = false;
            
            // Verificar si la dosis actual está en la lista de dosis altas
            for (var i = 0; i < highDoses.length; i++) {
                if (selectedDose.indexOf(highDoses[i]) !== -1 || highDoses[i].indexOf(selectedDose) !== -1) {
                    requiresVerification = true;
                    break;
                }
            }
            
            // Si requiere verificación, insertar el paso DESPUÉS de tirzepatide-shipment
            // o DESPUÉS de tirzepatide-dose si shipment no existe (caso 15mg)
            if (requiresVerification) {
                var verificationStepId = 'step-tirzepatide-verification';
                
                if (this.currentRoute.indexOf(verificationStepId) !== -1) {
                    return;
                }
                
                var shipmentIndex = this.currentRoute.indexOf('step-tirzepatide-shipment');
                var doseIndex = this.currentRoute.indexOf('step-tirzepatide-dose');
                var insertIndex = -1;
                
                if (shipmentIndex !== -1) {
                    insertIndex = shipmentIndex + 1;
                } else if (doseIndex !== -1) {
                    insertIndex = doseIndex + 1;
                }
                
                if (insertIndex !== -1) {
                    this.currentRoute.splice(insertIndex, 0, verificationStepId);
                }
            }
        },

        // Insertar paso de historial después de la verificación (para nuevos pacientes)
        insertTirzepatideHistoryStep: function() {
            var historyStepId = 'step-tirzepatide-history';
            var verificationIndex = this.currentRoute.indexOf('step-tirzepatide-verification');
            
            if (verificationIndex !== -1 && this.currentRoute.indexOf(historyStepId) === -1) {
                this.currentRoute.splice(verificationIndex + 1, 0, historyStepId);
            }
        },

        // Insertar ID upload y shipment-summary después del historial
        insertShipmentSummaryAfterHistory: function() {
            var idUploadStepId = 'step-id-upload';
            var summaryStepId = 'step-shipment-summary';
            var historyIndex = this.currentRoute.indexOf('step-tirzepatide-history');
            
            if (historyIndex !== -1) {
                // Insertar ID upload después del historial
                if (this.currentRoute.indexOf(idUploadStepId) === -1) {
                    this.currentRoute.splice(historyIndex + 1, 0, idUploadStepId);
                }
                // Insertar shipment-summary después del ID upload
                if (this.currentRoute.indexOf(summaryStepId) === -1) {
                    var idUploadIndex = this.currentRoute.indexOf(idUploadStepId);
                    this.currentRoute.splice(idUploadIndex + 1, 0, summaryStepId);
                }
            }
        },

        // Insertar shipment-summary después de la verificación (para pacientes Levers)
        insertShipmentSummaryAfterVerification: function() {
            var summaryStepId = 'step-shipment-summary';
            var verificationIndex = this.currentRoute.indexOf('step-tirzepatide-verification');
            
            if (verificationIndex !== -1 && this.currentRoute.indexOf(summaryStepId) === -1) {
                this.currentRoute.splice(verificationIndex + 1, 0, summaryStepId);
            }
        },

        // Agregar estos métodos dentro de window.QZ:
        showProcessingOverlay: function() {
            var overlay = document.getElementById('qz-processing-overlay');
            if(overlay) {
                overlay.style.setProperty('display', 'flex', 'important');
                overlay.classList.add('is-active');
            }
        },

        hideProcessingOverlay: function() {
            var overlay = document.getElementById('qz-processing-overlay');
            if(overlay) {
                overlay.style.setProperty('display', 'none', 'important');
                overlay.classList.remove('is-active');
            }
        },
        
        // Flag para prevenir doble-clic en selectAndNext
        _selectAndNextLocked: false,
        
        // Limpiar pasos condicionales de un step específico (cuando cambia la respuesta)
        clearConditionalSteps: function(key) {
            var navRules = CONFIG.CONDITIONAL_NAVIGATION[key];
            if (!navRules) return;
            
            var currentStepId = 'step-' + key;
            var currentStepIndex = this.currentRoute.indexOf(currentStepId);
            if (currentStepIndex === -1) return;
            
            var self = this;
            var stepsToRemove = [];
            
            // Recolectar TODOS los posibles pasos condicionales de TODAS las reglas de este step
            for (var possibleVal in navRules) {
                if (navRules.hasOwnProperty(possibleVal)) {
                    var rule = navRules[possibleVal];
                    if (rule.insertSteps) {
                        stepsToRemove = stepsToRemove.concat(rule.insertSteps);
                    }
                    if (rule.variantSteps) {
                        stepsToRemove = stepsToRemove.concat(rule.variantSteps);
                    }
                }
            }
            
            // Pasos especiales que se insertan dinámicamente (titration-warning, shipment-summary, etc.)
            var specialSteps = ['step-titration-warning', 'step-shipment-summary', 'step-tirzepatide-verification', 'step-tirzepatide-history', 'step-id-upload'];
            stepsToRemove = stepsToRemove.concat(specialSteps);
            
            // Eliminar los pasos si existen después del step actual
            stepsToRemove.forEach(function(stepToRemove) {
                var stepIndex = self.currentRoute.indexOf(stepToRemove);
                if (stepIndex !== -1 && stepIndex > currentStepIndex) {
                    self.currentRoute.splice(stepIndex, 1);
                }
            });
        },

        // Manejo especial de navegación para tirzepatide-dose
        // Lee la configuración desde CONFIG.CONDITIONAL_NAVIGATION['tirzepatide-dose']
        handleTirzepatideDoseNavigation: function(selectedDose) {
            var lastTakenTime = this.userData.answers['last-taken-time'];
            var timeValue = '';
            if (lastTakenTime && lastTakenTime.length > 0) {
                timeValue = Array.isArray(lastTakenTime) ? lastTakenTime[0] : lastTakenTime;
            }
            
            var currentStepIndex = this.currentRoute.indexOf('step-tirzepatide-dose');
            if (currentStepIndex === -1) return;
            
            var self = this;
            var doseConfig = CONFIG.CONDITIONAL_NAVIGATION['tirzepatide-dose'][selectedDose];
            if (!doseConfig) return;
            

            
            // CASO 1: Dosis máxima (15mg/week) - dos caminos según tiempo
            // - Tiempo reciente: verificación → shipment-summary
            // - Tiempo > 1 mes: titration-warning → shipment-summary
            if (doseConfig.skipShipmentStep) {
                this.userData._shipmentSummaryDoseType = 'same';
                
                // Siempre saltar tirzepatide-shipment (no aplica para dosis máxima)
                var skipIndex = self.currentRoute.indexOf('step-tirzepatide-shipment');
                if (skipIndex !== -1 && skipIndex > currentStepIndex) {
                    self.currentRoute.splice(skipIndex, 1);
                }
                
                // Tiempo > 1 mes: mostrar titration-warning
                if (timeValue === '1-3 months ago' || timeValue === 'More than 3 months ago') {
                    if (this.currentRoute.indexOf('step-titration-warning') === -1) {
                        this.currentRoute.splice(currentStepIndex + 1, 0, 'step-titration-warning');
                    }
                    if (this.currentRoute.indexOf('step-shipment-summary') === -1) {
                        var warningIndex = this.currentRoute.indexOf('step-titration-warning');
                        if (warningIndex !== -1) {
                            this.currentRoute.splice(warningIndex + 1, 0, 'step-shipment-summary');
                        }
                    }
                } 
                // Tiempo reciente: insertar verificación → shipment-summary
                else if (doseConfig.requiresVerification) {
                    if (this.currentRoute.indexOf('step-tirzepatide-verification') === -1) {
                        this.currentRoute.splice(currentStepIndex + 1, 0, 'step-tirzepatide-verification');
                    }
                    if (this.currentRoute.indexOf('step-shipment-summary') === -1) {
                        var verifyIndex = this.currentRoute.indexOf('step-tirzepatide-verification');
                        if (verifyIndex !== -1) {
                            this.currentRoute.splice(verifyIndex + 1, 0, 'step-shipment-summary');
                        }
                    }
                }
                return;
            }
            
            // CASO 2: Tiempo > 1 mes y dosis tiene showTitrationWarning - mostrar warning antes de shipment
            if ((timeValue === '1-3 months ago' || timeValue === 'More than 3 months ago') && doseConfig.showTitrationWarning !== false) {
                this.userData._shipmentSummaryDoseType = 'same';
                
                var stepsToSkip = ['step-tirzepatide-shipment', 'step-tirzepatide-verification', 'step-tirzepatide-history', 'step-id-upload'];
                stepsToSkip.forEach(function(skipStep) {
                    var skipIndex = self.currentRoute.indexOf(skipStep);
                    if (skipIndex !== -1 && skipIndex > currentStepIndex) {
                        self.currentRoute.splice(skipIndex, 1);
                    }
                });
                
                if (this.currentRoute.indexOf('step-titration-warning') === -1) {
                    this.currentRoute.splice(currentStepIndex + 1, 0, 'step-titration-warning');
                }
                if (this.currentRoute.indexOf('step-shipment-summary') === -1) {
                    var warningIndex = this.currentRoute.indexOf('step-titration-warning');
                    if (warningIndex !== -1) {
                        this.currentRoute.splice(warningIndex + 1, 0, 'step-shipment-summary');
                    }
                }
            }
            // CASO 3: Tiempo reciente - para dosis altas, asegurar que verification se inserte despues de shipment
            else if (doseConfig.requiresVerification) {
                var shipmentStepId = 'step-tirzepatide-shipment';
                var shipmentIdx = this.currentRoute.indexOf(shipmentStepId);
                if (shipmentIdx !== -1 && this.currentRoute.indexOf('step-tirzepatide-verification') === -1) {
                    this.currentRoute.splice(shipmentIdx + 1, 0, 'step-tirzepatide-verification');
                }
            }
            // FIN CASO 3
        },

        selectAndNext: function(el, key, val) {
            // Protección anti-doble-clic
            if (this._selectAndNextLocked) return;
            this._selectAndNextLocked = true;
            
            // Quitar foco (fix para iPhone)
            if(document.activeElement) document.activeElement.blur(); 

            var self = this;
            
            // Limpiar errores previos
            this.clearError('qz-' + key);

            // Verificar Knockout Rules (usando el sistema CONFIG actual)
            var knockoutRulesForStep = CONFIG.FORM_RULES.knockout[key];
            if (knockoutRulesForStep && knockoutRulesForStep[val]) {
                var rule = knockoutRulesForStep[val];
                // Efecto visual de selección
                var p = el.parentElement;
                p.querySelectorAll('.qz-option').forEach(function(o){ o.classList.remove('active-opt'); });
                el.classList.add('active-opt');
                
                // Mostrar knockout (adaptado al sistema actual)
                this.showKnockout(rule.title, rule.sub, rule.msg, rule.allowBack, rule.redirect);
                this._selectAndNextLocked = false; // Liberar lock
                return; 
            }

            // Selección visual con efecto
            var p = el.parentElement;
            p.querySelectorAll('.qz-option').forEach(function(o){ o.classList.remove('active-opt'); });
            el.classList.add('active-opt');
            
            // Guardar respuesta
            this.userData.answers[key] = val;

            this.evaluateConditionalNavigation(key, val);

            this.evaluateAgreementForSingleAnswer(key, val);

            // Delay de 500ms con feedback visual antes de avanzar (igual que runWithFeedback)
            setTimeout(function() {
                self.next();
                // Liberar lock después de completar la navegación
                setTimeout(function() {
                    self._selectAndNextLocked = false;
                }, 300);
            }, 500);
        },

        evaluateAgreementForSingleAnswer: function(key, val) {
            var self = this;
            var agreementRulesForStep = CONFIG.FORM_RULES.agreement[key];
            if (!agreementRulesForStep) return false;
            
            var rule = agreementRulesForStep[val];
            if (!rule) return false;
            
            var ruleKey = key + '_' + val.replace(/\s/g, '');
            var stepId = this.addAgreementStep(ruleKey, 'form');
            
            if (this.currentRoute.indexOf(stepId) === -1) {
                this.currentRoute.splice(this.stepIndex + 1, 0, stepId);
                return true;
            }
            return false;
        },

        evaluateConditionalNavigation: function(key, val) {
            var navRules = CONFIG.CONDITIONAL_NAVIGATION[key];
            if (!navRules) {
                return false;
            }
            
            var self = this;
            var currentStepId = 'step-' + key;
            var currentStepIndex = this.currentRoute.indexOf(currentStepId);
            if (currentStepIndex === -1) return false;
            
            var rule = navRules[val];
            if (!rule) return false;
            
            // 0. OBTENER TODOS LOS POSIBLES PASOS CONDICIONALES DE ESTE STEP
            // (para poder limpiarlos si la respuesta cambia)
            var allPossibleConditionalSteps = [];
            for (var possibleVal in navRules) {
                if (navRules.hasOwnProperty(possibleVal)) {
                    var ruleOrRules = navRules[possibleVal];
                    // Manejar tanto objetos simples como arrays de reglas
                    var rulesArray = Array.isArray(ruleOrRules) ? ruleOrRules : [ruleOrRules];
                    
                    rulesArray.forEach(function(possibleRule) {
                        if (possibleRule.insertSteps) {
                            allPossibleConditionalSteps = allPossibleConditionalSteps.concat(possibleRule.insertSteps);
                        }
                        if (possibleRule.variantSteps) {
                            allPossibleConditionalSteps = allPossibleConditionalSteps.concat(possibleRule.variantSteps);
                        }
                        if (possibleRule.skipSteps) {
                            allPossibleConditionalSteps = allPossibleConditionalSteps.concat(possibleRule.skipSteps);
                        }
                    });
                }
            }
            
            // 1. LIMPIAR: Remover cualquier paso condicional previamente insertado
            // que venga DESPUÉS del paso actual (siempre limpiar, incluso si no se cumplen condiciones)
            var stepsToRemove = [];
            for (var i = currentStepIndex + 1; i < this.currentRoute.length; i++) {
                if (allPossibleConditionalSteps.indexOf(this.currentRoute[i]) !== -1) {
                    stepsToRemove.push(this.currentRoute[i]);
                }
            }
            
            if (stepsToRemove.length > 0) {
                this.currentRoute = this.currentRoute.filter(function(stepId) {
                    return stepsToRemove.indexOf(stepId) === -1;
                });
            }
            
            // 2. VERIFICAR CONDICIONES ADICIONALES (lógica AND)
            // Si la regla tiene 'conditions', todas deben cumplirse
            if (rule.conditions) {
                var allConditionsMet = true;
                for (var conditionKey in rule.conditions) {
                    if (rule.conditions.hasOwnProperty(conditionKey)) {
                        var requiredValues = rule.conditions[conditionKey];
                        var actualValues = this.userData.answers[conditionKey];
                        
                        // Si no hay respuesta para esta condición, no se cumple
                        if (!actualValues || (Array.isArray(actualValues) && actualValues.length === 0)) {
                            allConditionsMet = false;
                            break;
                        }
                        
                        // Normalizar a array
                        if (!Array.isArray(requiredValues)) requiredValues = [requiredValues];
                        if (!Array.isArray(actualValues)) actualValues = [actualValues];
                        
                        // Verificar si algún valor actual coincide con los requeridos
                        var conditionMet = actualValues.some(function(actualVal) {
                            return requiredValues.indexOf(actualVal) !== -1;
                        });
                        
                        if (!conditionMet) {
                            allConditionsMet = false;
                            break;
                        }
                    }
                }
                // Si no se cumplen todas las condiciones, no insertar pasos (ya limpiamos arriba)
                if (!allConditionsMet) {
                    return false;
                }
            }
            
            // 3. DETERMINAR QUÉ PASOS INSERTAR (variantId check)
            var stepsToInsert = [];
            
            // Verificar si hay variantId específico y si coincide
            if (rule.variantId) {
                // Asegurar que orderContext existe
                var orderContext = this.userData.orderContext || {};
                var currentVariantId = String(orderContext.variantId || '');
                var allVariantIds = orderContext.allVariantIds || [];
                var targetVariantId = String(rule.variantId);
                
                // Verificar si el variantId está en la orden (como string para evitar problemas de tipo)
                var variantMatches = (currentVariantId === targetVariantId);
                
                // Si no hizo match directo, buscar en todos los variant IDs
                if (!variantMatches && allVariantIds.length > 0) {
                    variantMatches = allVariantIds.some(function(id) {
                        return String(id) === targetVariantId;
                    });
                }
                
                if (variantMatches && rule.variantSteps && rule.variantSteps.length > 0) {
                    stepsToInsert = rule.variantSteps;
                } else if (rule.insertSteps && rule.insertSteps.length > 0) {
                    // Fallback a insertSteps normales si no hay match o no hay variantSteps
                    stepsToInsert = rule.insertSteps;
                }
            } else {
                // Comportamiento normal sin variantId
                if (rule.insertSteps && rule.insertSteps.length > 0) {
                    stepsToInsert = rule.insertSteps;
                }
            }
            
            // (Este bloque duplicado fue eliminado - ya se maneja arriba)
            
            // 4. MANEJAR skipSteps (pasos a saltar según la respuesta)
            if (rule.skipSteps && rule.skipSteps.length > 0) {
                // Añadir a stepsToRemove para próximas navegaciones
                rule.skipSteps.forEach(function(skipStep) {
                    var skipIndex = self.currentRoute.indexOf(skipStep);
                    if (skipIndex !== -1 && skipIndex > currentStepIndex) {
                        self.currentRoute.splice(skipIndex, 1);
                    }
                });
            }
            
            // 4b. GUARDAR doseType si existe (para renderShipmentSummary)
            if (rule.doseType) {
                this.userData._shipmentSummaryDoseType = rule.doseType;
            }
            
            // 5. INSERTAR: Si hay pasos determinados, insertarlos
            if (stepsToInsert.length === 0) {
                return false; // No hay pasos que insertar para esta respuesta
            }
            
            // Recalcular índice después de limpieza
            currentStepIndex = this.currentRoute.indexOf(currentStepId);
            if (currentStepIndex === -1) return false;
            
            // Encontrar la posición correcta para insertar:
            // Buscar pasos intermedios del flujo GLP (como step-last-taken-time)
            // e insertar DESPUÉS de ellos para mantener el orden lógico
            var insertPosition = currentStepIndex + 1;
            
            // Buscar step-last-taken-time en la ruta actual (si existe)
            var lastTakenTimeIndex = this.currentRoute.indexOf('step-last-taken-time');
            if (lastTakenTimeIndex !== -1 && lastTakenTimeIndex > currentStepIndex) {
                insertPosition = lastTakenTimeIndex + 1;
            }
            
            stepsToInsert.forEach(function(stepToInsert, index) {
                if (document.getElementById(stepToInsert)) {
                    if (self.currentRoute.indexOf(stepToInsert) === -1) {
                        self.currentRoute.splice(insertPosition + index, 0, stepToInsert);
                    }
                }
            });
            
            return true;
        },

        handleAgreement: function(decision) {
            var currentStepEl = document.getElementById(this.currentRoute[this.stepIndex]);
            if (!currentStepEl) {
                // Current step element not found
                return;
            }
            
            var ruleKey = currentStepEl.dataset.ruleKey;
            var ruleType = currentStepEl.dataset.ruleType;
            
            if (!ruleKey || !ruleType) {
                this.next();
                return;
            }
            
            var rule = this.getRule(ruleKey, ruleType);
            
            if (!rule) {
                // Rule not found
                this.next();
                return;
            }

            if (decision === 'agree') {
                if (!this.userData.agreements_accepted) this.userData.agreements_accepted = [];
                
                var category = rule.category || ruleKey.split('_')[0];
                var condition = '';
                
                if (ruleType === 'preload') {
                    // Para preload, usar el primer conditionValue válido
                    if (Array.isArray(rule.conditionValue) && rule.conditionValue.length > 0) {
                        condition = rule.conditionValue[0];
                    } else if (rule.conditionValue && String(rule.conditionValue).trim() !== '') {
                        condition = rule.conditionValue;
                    }
                } else if (ruleType === 'form') {
                    var stepKey = ruleKey.split('_')[0];
                    var answerNormalized = ruleKey.substring(stepKey.length + 1);
                    var stepRules = CONFIG.FORM_RULES.agreement[stepKey];
                    if (stepRules) {
                        for (var ansKey in stepRules) {
                            if(ansKey.replace(/\s/g, '') === answerNormalized){
                                condition = ansKey;
                                break;
                            }
                        }
                    }
                }
                
                // Solo guardar si hay condition válida
                if (condition && String(condition).trim() !== '') {
                    this.userData.agreements_accepted.push({
                        category: category,
                        condition: condition,
                        agreement_title: rule.title,
                        agreement_text: rule.sub || rule.text || '',
                        attestation: rule.btnAgree || 'I Understand & Agree',
                        timestamp: new Date().toISOString()
                    });
                }
                
                this.next();
            } else {
                // ✅ NUEVO: Mostrar knockout al declinar, igual que universal_form.js
                if (rule.knockout) {
                    this.showKnockout(
                        rule.knockout.title || "Consultation Stopped",
                        rule.knockout.sub || "<strong>We are sorry!</strong><br><br>To proceed with your order, you must accept this agreement, you can request a refund on the button below, if so, it will processed within 24 hours",
                        rule.knockout.msg || "",
                        true,
                        "REFUND_REQUEST"
                    );
                } else {
                    // Fallback por si no hay metadata de knockout
                    this.showKnockout(
                        "Consultation Stopped",
                        "<strong>We are sorry!</strong><br><br>To proceed with your order, you must accept this agreement, you can request a refund on the button below, if so, it will processed within 24 hours",
                        "",
                        true,
                        "REFUND_REQUEST"
                    );
                }
            }
        },

        getRule: function(ruleKey, type) {
            if (type === 'preload') {
                return CONFIG.PRELOAD_RULES.agreement[ruleKey];
            }
            if (type === 'form') {
                var parts = ruleKey.split('_');
                var stepKey = parts[0];
                var answerKey = ruleKey.substring(stepKey.length + 1);
                var originalAnswer = '';
                var stepOptions = CONFIG.FORM_RULES.agreement[stepKey];
                for(var key in stepOptions){
                    if(key.replace(/\s/g, '') === answerKey){
                        originalAnswer = key;
                        break;
                    }
                }
                return CONFIG.FORM_RULES.agreement[stepKey][originalAnswer];
            }
            return null;
        },

        submitForm: function() {
            var self = this;
            var hpField = document.getElementById('qz-hp-field');
            if (hpField && hpField.value !== '') {
                // Bot detected - rechazar silenciosamente
                return; // Silenciosamente rechazar bots
            }
            
            // Verificar si estamos en el paso final de submit
            var isFinalSubmitStep = this.currentRoute[this.stepIndex] === 'step-final-submit';
            
            // Función que contiene el proceso de envío original
            var submitProcess = function() {
                self.showProcessingOverlay();
                self.isSubmitting = true;
                
                // Preparar payload de forma asíncrona (para compresión de imagen)
                self.preparePayloadAsync().then(function(payload) {
                    // Guardar datos ANTES de limpiar
                    var savedOrderId = self.userData.orderContext.orderId;
                var savedRedirect = self.formToRedirect;
                // Agregar nonce
                payload._nonce = Date.now().toString(36) + Math.random().toString(36).substr(2);
                var fetchOptions = {
                    method: 'POST',
                    mode: 'cors',
                    credentials: 'omit',
                    headers: {
                    'Content-Type': 'application/json',
                    'Accept': 'application/json',
                    'X-Request-Nonce': payload._nonce
                    },
                    body: JSON.stringify(payload)
                };
                function doSubmit(url, isFallback) {
                    fetch(url, fetchOptions).then(function(res) {
                        if (!res.ok) throw new Error("HTTP " + res.status);
                        return res.text();
                    }).then(function(data) {
                        // Limpieza HIPAA completa
                        self.userData = {
                        answers: {},
                        orderContext: {},
                        existingAgreements: [],
                        _normalized: {},
                        first_name: null,
                        last_name: null,
                        email: null,
                        phone: null,
                        State_of_Residence: null,
                        Date_of_Birth: null,
                        Biological_Sex: null,
                        Pregnancy_And_Hormonal_Status: null,
                        Diabetes_Insulin_Resistance_History: null,
                        Digestive_Conditions: null,
                        History_of_Cancer: null,
                        Thyroid_Details: null,
                        Mental_Health_History: null
                        };
                        self.formToRedirect = null;
                        self.stepIndex = 0;
                        self.currentRoute = [];
                        if (window.gc) window.gc();
                        // Redirección
                        if (savedRedirect && savedRedirect.trim() !== '') {
                        var redirectUrl = savedRedirect;
                        var separator = redirectUrl.indexOf('?') > -1 ? '&' : '?';
                        var finalUrl = redirectUrl + separator + 'order_id=' + encodeURIComponent(savedOrderId);
                        window.location.href = finalUrl;
                        } else {
                        window.location.href = "https://levers.health/pages/thank-you-for-your-submission";
                        }
                    }).catch(function(e) {
                        if (!isFallback && CONFIG.WEBHOOK_SUBMIT_FALLBACK) {
                            doSubmit(CONFIG.WEBHOOK_SUBMIT_FALLBACK, true);
                        } else {
                            // Error submitting form (primary and fallback failed)
                            self.isSubmitting = false;
                            self.hideProcessingOverlay();
                            alert("Error submitting form. Please try again.");
                        }
                    });
                }
                
                doSubmit(CONFIG.WEBHOOK_SUBMIT, false);
                }).catch(function(err) {
                    // Error preparing payload (compresión de imagen)
                    self.isSubmitting = false;
                    self.hideProcessingOverlay();
                    alert("Error processing form data. Please try again.");
                });
            };
            
            if (isFinalSubmitStep) {
                // Disparar confeti con la misma configuración que ya existe en tu código
                var isMobile = window.innerWidth < 768;
                var colors = ['#12315E', '#86ACD1', '#F2D06B', '#4CAF50', '#FF5252'];
                
                // CONFIGURACIÓN BASE: Más fuerza y más tiempo de vuelo
                var baseConfig = {
                    colors: colors,
                    zIndex: 2147483647,
                    ticks: 300,       // Reducido de 500 a 300 (dura menos tiempo)
                    gravity: 0.8,     // Aumentado de 0.6 a 0.8 (caen más rápido)
                    decay: 0.93,      // Aumentado de 0.91 a 0.93 (menos tiempo en aire)
                    startVelocity: 55, // Reducido de 65 a 55 (menos distancia)
                    spread: 50        // Reducido de 60 a 50 (más concentrado)
                    };
                    
                    if (isMobile) {
                    // MÓVIL: Disparo desde abajo (más concentrado)
                    var originsX = [0.3, 0.5, 0.7];  // Reducido de 5 a 3 cañones
                    originsX.forEach(function(xPos) {
                        confetti(Object.assign({}, baseConfig, {
                        particleCount: 40,  // Aumentado de 30 a 40 por cañón (más denso)
                        angle: 90,
                        origin: { x: xPos, y: 1 }
                        }));
                    });
                    } else {
                    // DESKTOP: Disparo desde los lados (más rápido)
                    confetti(Object.assign({}, baseConfig, {
                        particleCount: 120,  // Aumentado para mayor densidad
                        angle: 60,
                        origin: { x: 0, y: 0.6 }
                    }));
                    
                    confetti(Object.assign({}, baseConfig, {
                        particleCount: 120,  // Aumentado para mayor densidad
                        angle: 120,
                        origin: { x: 1, y: 0.6 }
                    }));
                }
                
                // Esperar 1.5 segundos antes de continuar con el procesamiento
                setTimeout(submitProcess, 1500); // 1.5 segundos de delay
            } else {
                // No es el paso final de submit, continuar normalmente
                submitProcess();
            }
        },

        preparePayloadAsync: function() {
            var self = this;
            
            return new Promise(function(resolve, reject) {
                var responses = {};
                var compressionPromises = [];
                
                for (var key in self.userData.answers) {
                    if (self.userData.answers.hasOwnProperty(key)) {
                        var rawVal = self.userData.answers[key];
                        var config = STEP_CONFIG[key];

                        if (key === 'conditional' && typeof rawVal === 'object' && rawVal !== null) {
                            for (var condKey in rawVal) {
                                if (rawVal.hasOwnProperty(condKey)) {
                                    var condVal = rawVal[condKey];
                                    try {
                                        var validatedValue = SecurityUtils.validateMedicalInput(condKey, condVal);
                                        responses[condKey] = self.decodeEntities(validatedValue);
                                    } catch (validationError) {
                                        reject(new Error('Invalid input detected in field: ' + condKey));
                                        return;
                                    }
                                }
                            }
                            continue;
                        }
                        
                        // Solo procesar si hay valores
                        if (Array.isArray(rawVal) && rawVal.length > 0) {
                            var finalString = '';
                            
                            if (config && config.optionPrefix) {
                                var mappedValues = rawVal.map(function(val, index) {
                                    return config.optionPrefix + ' ' + (index + 1);
                                });
                                finalString = mappedValues.join(', ');
                            } else {
                                finalString = rawVal.filter(function(v) { 
                                    return v && v !== ""; 
                                }).join(', ');
                            }
                            
                            if (finalString !== "") {
                                try {
                                    var validatedValue = SecurityUtils.validateMedicalInput(key, finalString);
                                    responses[key] = self.decodeEntities(validatedValue);
                                } catch (validationError) {
                                    reject(new Error('Invalid input detected in field: ' + key));
                                    return;
                                }
                            }
                        } else if (typeof rawVal === 'string' && rawVal !== '') {
                            responses[key] = self.decodeEntities(self.sanitizeInput(rawVal));
                        } else if (key === 'id-upload' && typeof rawVal === 'object' && rawVal !== null) {
                            // Para subida de ID - comprimir y convertir a base64
                            if (rawVal.preview) {
                                (function(idData) {
                                    compressionPromises.push(
                                        self.compressImage(idData.preview, 1200, 1200, 0.7)
                                            .then(function(compressedBase64) {
                                                responses['id-upload'] = {
                                                    uploaded: true,
                                                    fileName: idData.file ? idData.file.name : null,
                                                    fileType: idData.file ? idData.file.type : null,
                                                    fileSize: idData.file ? idData.file.size : null,
                                                    imageBase64: compressedBase64
                                                };
                                            })
                                            .catch(function() {
                                                // Si falla compresión, enviar sin imagen
                                                responses['id-upload'] = {
                                                    uploaded: true,
                                                    fileName: idData.file ? idData.file.name : null,
                                                    fileType: idData.file ? idData.file.type : null,
                                                    fileSize: idData.file ? idData.file.size : null
                                                };
                                            })
                                    );
                                })(rawVal);
                            } else {
                                responses['id-upload'] = {
                                    uploaded: true,
                                    fileName: rawVal.file ? rawVal.file.name : null,
                                    fileType: rawVal.file ? rawVal.file.type : null,
                                    fileSize: rawVal.file ? rawVal.file.size : null
                                };
                            }
                        }
                    }
                }

                // Esperar a que todas las compresiones terminen
                Promise.all(compressionPromises).then(function() {
                    var agreements = self.userData.agreements_accepted || [];
                    var legal = {
                        agreements_accepted: agreements,
                        total_agreements: agreements.length
                    };
                    
                    resolve({
                        ts: new Date().toISOString(),
                        order_id: self.userData.orderContext.orderId,
                        product_id: CONFIG.PRODUCT_ID,
                        form_type: 'secondary_form',
                        answers: responses,
                        legal: legal,
                        _csrf: CONFIG.CSRF_TOKEN,
                        _nonce: Date.now().toString(36) + Math.random().toString(36).substr(2)
                    });
                }).catch(reject);
            });
        },

        renderAgreementContent: function(stepEl) {
            var ruleKey = stepEl.dataset.ruleKey;
            var ruleType = stepEl.dataset.ruleType;
            if (!ruleKey || !ruleType) {
                // No ruleKey or ruleType for step
                return;
            }
            
            var rule = this.getRule(ruleKey, ruleType);
            if (!rule) {
                // Rule not found
                return;
            }

            var titleEl = stepEl.querySelector('#qz-agree-title');
            var subEl = stepEl.querySelector('#qz-agree-sub');
            var textWrapper = stepEl.querySelector('#qz-agree-text-wrapper');
            var btnAgree = stepEl.querySelector('#qz-btn-agree');
            var btnDisagreeEl = stepEl.querySelector('#qz-btn-disagree');
            
            if(titleEl) titleEl.innerHTML = rule.title || '';
            if(subEl) subEl.innerHTML = rule.sub || '';
            
            if (textWrapper) {
                if (rule.text && rule.text.trim() !== "") {
                    textWrapper.style.display = 'block';
                    var textEl = textWrapper.querySelector('#qz-agree-text');
                    if(textEl) textEl.innerHTML = rule.text;
                } else {
                    textWrapper.style.display = 'none';
                }
            }
            
            if(btnAgree) btnAgree.innerText = rule.btnAgree || 'I Understand & Agree';
            if(btnDisagreeEl) {
                btnDisagreeEl.innerHTML = rule.btnDisagree || 'I Decline';
                btnDisagreeEl.setAttribute('data-redirect', rule.redirectUrl || '');
            }
        },

        showKnockout: function(title, subtitle, message, showBackButton, exitUrl) {
            var overlay = document.getElementById('qz-knockout-overlay');
            var titleEl = document.getElementById('qz-knockout-title');
            var subEl = document.getElementById('qz-knockout-sub');
            var msgEl = document.getElementById('qz-knockout-message');
            var backBtn = document.getElementById('qz-knockout-back');
            var exitBtn = document.getElementById('qz-knockout-exit');

            // Configurar contenido
            if (titleEl) titleEl.innerHTML = title || "Not Eligible";

            // Subtítulo (nuevo elemento)
            if (subEl) {
                if (subtitle && subtitle.trim() !== "") {
                    subEl.innerHTML = subtitle;
                    subEl.style.display = 'block';
                } else {
                    subEl.innerHTML = "";
                    subEl.style.display = 'none';
                }
            }

            if (msgEl) msgEl.innerHTML = message || "";

            // Configurar botón de retroceso
            if (backBtn) {
                if (showBackButton) {
                    backBtn.style.display = 'block';
                    backBtn.onclick = function() {
                        this.closeKnockout();
                    }.bind(this);
                } else {
                    backBtn.style.display = 'none';
                }
            }

            // Configurar botón de salida (ahora dinámico para refund o exit)
            if (exitBtn) {
                if (exitUrl === "REFUND_REQUEST") {
                    exitBtn.innerHTML = "<span>Request Refund</span>";
                    // Remover clase qz-btn-agree-glow si existe para mantener el estilo rojo del knockout
                    exitBtn.classList.remove('qz-btn-agree-glow');
                    exitBtn.onclick = function() {
                        this.submitRefundRequest(title + " - " + (subtitle || "No subtitle"));
                    }.bind(this);
                } else {
                    exitBtn.onclick = function() {
                        if (exitUrl) {
                            window.location.href = exitUrl;
                        } else {
                            window.location.href = "https://levers.health";
                        }
                    };
                }
            }

            // Mostrar overlay
            if (overlay) {
                overlay.classList.add('is-visible');
                document.body.style.overflow = 'hidden'; // Bloquear scroll
            }

            // Efecto de shake en el paso actual si existe
            var currentStep = document.querySelector('.qz-step.active-step');
            if (currentStep) {
                currentStep.classList.add('knockout-shake');
                setTimeout(function() {
                    currentStep.classList.remove('knockout-shake');
                }, 500);
            }
        },
        
        closeKnockout: function() {
            var overlay = document.getElementById('qz-knockout-overlay');
            if (overlay) {
                overlay.classList.remove('is-visible');
                document.body.style.overflow = '';
            }

            // Limpiar mensajes
            var subEl = document.getElementById('qz-knockout-sub');
            if (subEl) subEl.style.display = 'none';
            
            // Resetear botones del knockout
            var exitBtn = document.getElementById('qz-knockout-exit');
            var backBtn = document.getElementById('qz-knockout-back');
            if (exitBtn) {
                exitBtn.disabled = false;
                exitBtn.innerHTML = '<span>Exit Form & Request Refund</span>';
            }
            if (backBtn) backBtn.disabled = false;
        },
        
        handleKnockoutExit: function(redirect) {
            if (redirect === 'REFUND_REQUEST') {
                this.submitRefundRequest();
            } else {
                window.location.href = redirect || "https://levers.health/pages/refund-request";
            }
        },
        
        // ✅ NUEVO: Función para solicitar refund desde knockout
        submitRefundRequest: function(reason) {
            var self = this;
            var exitBtn = document.getElementById('qz-knockout-exit');
            
            if (exitBtn) {
                exitBtn.disabled = true;
                exitBtn.innerHTML = '<span>Processing...</span>';
            }
            
            var payload = {
                ts: new Date().toISOString(),
                order_id: this.urlOrderId || this.userData.orderContext.orderId || "unknown",
                client: {
                    fn: this.userData.first_name || "",
                    ln: this.userData.last_name || "",
                    em: this.userData.email || "",
                    ph: this.userData.phone || ""
                },
                refund_reason: reason || "Medical Agreement Disagree - NAD Form",
                product_id: CONFIG.PRODUCT_ID,
                _nonce: Date.now().toString(36) + Math.random().toString(36).substr(2)
            };
            
            fetch(CONFIG.WEBHOOK_REFUND || "https://n8n-shopify-proxy.eduardo-ba5.workers.dev/refund", {
                method: 'POST',
                mode: 'cors',
                headers: {
                    'Content-Type': 'application/json',
                    'Accept': 'application/json',
                    'X-Request-Nonce': payload._nonce
                },
                body: JSON.stringify(payload)
            })
            .then(function(res) {
                if (!res.ok) throw new Error("Status " + res.status);
                return res.text();
            })
            .then(function() {
                if (exitBtn) {
                    exitBtn.innerHTML = '<span>Refund Requested ✓</span>';
                }
                
                setTimeout(function() {
                    var orderId = self.urlOrderId || self.userData.orderContext.orderId || "unknown";
                    
                    // ✅ Después del refund, ir al siguiente formulario si existe
                    if (self.formToRedirect && typeof self.formToRedirect === 'string' && self.formToRedirect.trim() !== '') {
                        var redirectUrl = self.formToRedirect.trim();
                        var separator = redirectUrl.indexOf('?') > -1 ? '&' : '?';
                        var finalUrl = redirectUrl + separator + 'order_id=' + encodeURIComponent(orderId);
                        window.location.href = finalUrl;
                    } else {
                        // Si no hay siguiente formulario, ir al home
                        window.location.href = "https://levers.health/pages/thank-you-for-your-submission";
                    }
                }, 2000);
            })
            .catch(function(err) {
                // Refund webhook error
                if (exitBtn) {
                    exitBtn.disabled = false;
                    exitBtn.innerHTML = '<span>Error - Try Again</span>';
                }
                // Fallback: redirigir a página de refund manual
                window.location.href = "https://levers.health/pages/refund-request";
            });
        },

        handleKnockoutBack: function() {
            this.hideKnockout();
            this.clearLastKnockoutSelection();
        },
        
        clearLastKnockoutSelection: function() {
            var currentStepId = this.currentRoute[this.stepIndex];
            var stepEl = document.getElementById(currentStepId);
            if (!stepEl) return;
            
            var key = currentStepId.replace('step-', '');
            var listContainer = document.getElementById(key + '-list') || stepEl.querySelector('.qz-list');
            
            // Limpiar TODAS las selecciones activas y deshabilitadas en este step
            if (listContainer) {
                listContainer.querySelectorAll('.qz-option').forEach(function(opt) {
                    opt.classList.remove('active-opt', 'disabled-option');
                });
            }
            
            // Resetear el array de respuestas para este step
            this.userData.answers[key] = [];
            
            // Actualizar contador si existe (para steps con toggleMultiLimited)
            var config = STEP_CONFIG[key];
            if (config) {
                this.updateCounter(key, config.min, config.max);
            }
            
            // Limpiar error si existe
            this.clearError('qz-' + key);
        },

        // Generar input/textarea según STEP_CONFIG
        generateShortTextField: function(stepEl, config) {
            var container = stepEl.querySelector('.short-text-container');
            if (!container) return null;
            
            // Limpiar contenedor
            container.innerHTML = '';
            
            var field;
            
            if (config.isTextarea) {
                field = document.createElement('textarea');
                field.rows = 4;
                field.className = 'qz-input qz-textarea-input short-text-field';
            } else {
                field = document.createElement('input');
                field.type = 'text';
                field.className = 'qz-input qz-short-text-input short-text-field';
            }
            
            // Aplicar atributos de STEP_CONFIG
            field.placeholder = config.placeholder || 'Type your answer here...';
            field.setAttribute('maxlength', config.maxLength);
            
            if (config.autocomplete) {
                field.setAttribute('autocomplete', config.autocomplete);
            }
            
            if (config.dataLpignore) {
                field.setAttribute('data-lpignore', config.dataLpignore);
            }
            
            container.appendChild(field);
            return field;
        },

        // Validación
        validateShortText: function(stepId) {
            var stepEl = document.getElementById(stepId);
            if (!stepEl) {
                this.next();
                return;
            }
            
            var stepKey = stepId.replace('step-', '');
            var config = STEP_CONFIG[stepKey];
            
            if (!config) {
                // No STEP_CONFIG for step
                this.next();
                return;
            }
            
            var inputEl = stepEl.querySelector('.short-text-field');
            var errorEl = stepEl.querySelector('.qz-short-text-error');
            
            if (!inputEl) {
                this.next();
                return;
            }
            
            var rawValue = inputEl.value.trim();
            
            // Validaciones
            if (config.required && rawValue.length === 0) {
                this.showShortTextError(inputEl, errorEl, 'This field is required.');
                return;
            }
            
            if (rawValue.length > 0 && rawValue.length < config.minLength) {
                this.showShortTextError(inputEl, errorEl, config.errorMsg);
                return;
            }
            
            if (rawValue.length > config.maxLength) {
                this.showShortTextError(inputEl, errorEl, 'Response too long.');
                return;
            }
            
            // Seguridad
            var sanitizedValue;
            try {
                sanitizedValue = SecurityUtils.validateMedicalInput(stepKey, rawValue);
                sanitizedValue = sanitizedValue
                    .replace(/&/g, '&amp;')
                    .replace(/</g, '&lt;')
                    .replace(/>/g, '&gt;')
                    .replace(/"/g, '&quot;')
                    .replace(/'/g, '&#39;');
            } catch (e) {
                this.showShortTextError(inputEl, errorEl, 'Invalid input detected.');
                return;
            }
            
            this.userData.answers[stepKey] = sanitizedValue;
            
            inputEl.classList.remove('input-error');
            if (errorEl) {
                errorEl.textContent = '';
                errorEl.classList.remove('show-error');
            }
            
            this.next();
        },

        showShortTextError: function(inputEl, errorEl, msg) {
            if (inputEl) {
                inputEl.classList.add('input-error');
                inputEl.style.animation = 'qz-shake 0.5s ease-in-out';
                setTimeout(function() { inputEl.style.animation = ''; }, 500);
            }
            if (errorEl) {
                errorEl.textContent = msg;
                errorEl.classList.add('show-error');
            }
        },

        showError: function(id, msg) {
            var errDiv = document.getElementById(id + '-error');
            if(errDiv) { errDiv.innerText = msg; errDiv.classList.add('show-error'); }
        },
        clearError: function(id) {
            var errDiv = document.getElementById(id + '-error');
            if(errDiv) { errDiv.classList.remove('show-error'); errDiv.innerText = ''; }
        },
        showOverlay: function(title, msg) {
            var overlay = document.getElementById('qz-generic-overlay');
            if(overlay) {
                overlay.querySelector('#qz-overlay-title').innerHTML = title;
                overlay.querySelector('#qz-overlay-msg').innerHTML = msg;
                overlay.classList.add('is-visible');
            }
        },
        closeOverlay: function() {
            var overlay = document.getElementById('qz-generic-overlay');
            if(overlay) overlay.classList.remove('is-visible');
        },
        handleGenericExit: function() {
            window.location.href = '/';
        },
        hideLoader: function() {
            var loader = document.getElementById('qz-loader');
            if(loader) loader.style.setProperty('display', 'none', 'important');
        },
        setupUIHelpers: function() {
            document.querySelectorAll('.qz-step').forEach(function(step) {
                if (step.id === 'step-welcome') return;

                var btn = step.querySelector('.qz-btn');
                if (btn) {
                    if (step.querySelector('.qz-sticky-footer') || btn.parentElement.classList.contains('qz-sticky-footer')) return;
                    
                    var wrapper = document.createElement('div');
                    wrapper.className = 'qz-sticky-footer';
                    
                    if (btn.parentNode) {
                        btn.parentNode.insertBefore(wrapper, btn);
                        wrapper.appendChild(btn);
                    }
                }
            });
        },
        applySecurityShield: function() {
            document.querySelectorAll('#qz-wrapper input, #qz-wrapper textarea, #qz-wrapper select').forEach(function(el) {
                el.setAttribute('autocomplete', 'off');
                el.setAttribute('data-lpignore', 'true');
                el.setAttribute('data-sensitive', 'true');
                el.classList.add('dd-privacy-hidden');
            });
        },
        sanitizeInput: function(str) {
            return typeof str !== 'string' ? str : str.replace(/[&<>'"]/g, function(tag) {
                return { '&': '&amp;', '<': '&lt;', '>': '&gt;', "'": '&#39;', '"': '&quot;' }[tag] || tag;
            });
        },
        decodeEntities: function(str) {
            if (!str) return str;
            var txt = document.createElement("textarea");
            txt.innerHTML = str;
            return txt.value;
        }
    };

    if (document.readyState === "loading") {
        document.addEventListener("DOMContentLoaded", function() { window.QZ.init(); });
    } else {
        window.QZ.init();
    }

})();

(function() {
    var confettiFired = false;
    
    function initConfettiObserver() {
        // Observamos los cambios en el DOM sin tocar tu lógica original
        var observer = new MutationObserver(function(mutations) {
            mutations.forEach(function(mutation) {
                if (mutation.attributeName === 'class') {
                    var target = mutation.target;
                    
                    // Detectamos si el paso final o de confirmación se acaba de activar
                    if ((target.id === 'step-final-submit' || target.id === 'step-confirmation') && 
                        target.classList.contains('active-step')) {
                        /*
                        if (!confettiFired) {
                            confettiFired = true; // Evita que se dispare dos veces
                            
                            var isMobile = window.innerWidth < 768;
                            var colors = ['#12315E', '#86ACD1', '#F2D06B', '#4CAF50', '#FF5252'];
                            
                            // CONFIGURACIÓN BASE: Más fuerza y más tiempo de vuelo
                            var baseConfig = {
                                colors: colors,
                                zIndex: 2147483647,
                                ticks: 500,        // Duran mucho más tiempo en pantalla (por defecto es 200)
                                gravity: 0.6,      // Caen más lento, flotan más (por defecto es 1)
                                decay: 0.91,       // Mantienen la velocidad horizontal por más tiempo
                                startVelocity: 65, // Salen con mucha más fuerza (por defecto es 45)
                                spread: 60         // Amplitud del disparo
                            };

                            if (isMobile) {
                                // MÓVIL: Disparo desde abajo (y: 1)
                                // Para abarcar el 60% del ancho, disparamos 5 pequeños cañones simultáneos 
                                // distribuidos desde el 20% (0.2) hasta el 80% (0.8) de la pantalla.
                                var originsX = [0.2, 0.35, 0.5, 0.65, 0.8];
                                
                                originsX.forEach(function(xPos) {
                                    confetti(Object.assign({}, baseConfig, {
                                        particleCount: 30, // 30 papeles x 5 cañones = 150 en total
                                        angle: 90,         // Disparo recto hacia arriba
                                        origin: { x: xPos, y: 1 }
                                    }));
                                });
                            } else {
                                // DESKTOP: Disparo desde los lados (como lo tenías, pero con más fuerza)
                                
                                // Cañón Izquierdo
                                confetti(Object.assign({}, baseConfig, {
                                    particleCount: 100,
                                    angle: 60,
                                    origin: { x: 0, y: 0.6 }
                                }));
                                
                                // Cañón Derecho
                                confetti(Object.assign({}, baseConfig, {
                                    particleCount: 100,
                                    angle: 120,
                                    origin: { x: 1, y: 0.6 }
                                }));
                            }
                        }
                        */
                    } else if ((target.id === 'step-final-submit' || target.id === 'step-confirmation') && 
                               !target.classList.contains('active-step')) {
                        // Reseteamos por si el usuario retrocede y vuelve a avanzar
                        confettiFired = false;
                    }
                }
            });
        });

        // Aplicamos el observador a los dos posibles pasos finales
        var stepFinal = document.getElementById('step-final-submit');
        var stepConfirm = document.getElementById('step-confirmation');
        
        if (stepFinal) observer.observe(stepFinal, { attributes: true });
        if (stepConfirm) observer.observe(stepConfirm, { attributes: true });
    }

    // Ejecutar de forma segura sin importar cuándo cargue el script
    if (document.readyState === "loading") {
        document.addEventListener("DOMContentLoaded", initConfettiObserver);
    } else {
        initConfettiObserver();
    }
})();